<template>
  <div v-touch:swipe.left="swipeLHandler">
    <div class="Loc MobileHide">
      <div
        v-if="MatchStats.match"
        style="
          background: #2c2d31;
          height: 45px;
          line-height: 3;
          font-size: 13px;
        "
      >
        <router-link
          style="color: lightgrey !important; text-decoration: none"
          id=""
          :to="{ name: 'LeaguePageNav', params: { leagueId: tournId } }"
          ><img
            :src="
              'https://sportapi.zuniac.com/tournament/logo/' +
              MatchStats.match.tournament.id
            "
            style="width: 25px; margin-left: 10px"
            alt=""
          />
          {{
            MatchStats.match.tournament.name | transliterate(cookiesObject.lang)
          }}
        </router-link>
        <span style="float: right; margin-right: 10px; color: lightgrey">
          {{ MatchStats.match.matchTime | transliterate(cookiesObject.lang) }}
        </span>
      </div>
      <div v-if="MatchStats.match">
        <div class="row" style="margin-top: 20px">
          <div class="col" style="text-align: center">
            <router-link
              id="routerLink"
              :to="{
                name: 'teamPage',
                params: { id: MatchStats.match.team1.id },
              }"
              ><img
                style="width: 90px; margin-top: 10px"
                :src="teamLogo + MatchStats.match.team1.id"
            /></router-link>
            <p style="color: white; margin-top: 50px">
              <img
                v-if="favs.some((fav) => fav.id === MatchStats.match.team1.id)"
                v-on:click="
                  removeFavorite({
                    value: MatchStats.match.team1.id,
                    type: team,
                  })
                "
                :src="favImage1"
                style="width: 15px; margin-bottom: 3px; cursor: pointer"
                alt=""
              />
              <img
                v-else
                v-on:click="
                  addToFavorites({
                    value: MatchStats.match.team1.id,
                    type: team,
                  })
                "
                :src="favImage"
                style="width: 15px; margin-bottom: 3px; cursor: pointer"
                alt=""
              />
              <span style="margin-right: 15px">
                {{ team1name | transliterate(cookiesObject.lang) }}
              </span>
            </p>
          </div>
          <div class="col" style="text-align: center">
            <label
              :class="{ active: isActive }"
              class="toggle__button"
              style="margin-right: 12px"
            >
              <input
                v-on:change="setNot()"
                type="checkbox"
                v-model="checkedValue"
              />
              <span class="toggle__switch"></span>
            </label>
            <h1
              class="MobileHide"
              style="color: white; margin-top: 25px; font-weight: bold"
              v-if="
                MatchStats.match.matchStatus.name == 'NS' ||
                MatchStats.match.matchStatus.name == 'POSTP' ||
                MatchStats.match.matchStatus.name == 'CANCL' ||
                MatchStats.match.matchStatus.name == 'TBA'
              "
            >
              -
            </h1>
            <h1
              class="MobileHide"
              style="color: white; margin-top: 25px; font-weight: bold"
              v-else
            >
              {{
                MatchStats.match.currentScore
                  | transliterate(cookiesObject.lang)
              }}
            </h1>
            <h5
              v-if="MatchStats.match.matchStatus.name == 'LIVE'"
              style="margin-top: 25px; font-size: 14px"
              class="pop1"
            >
              Live {{ calculateMinutes(MatchStats.match.counterStartTime) }}'
            </h5>
            <h5
              v-else-if="MatchStats.match.matchStatus.name == 'HT'"
              style="color: white; margin-top: 25px; font-size: 14px"
            >
              HT
            </h5>
            <h5 v-else style="color: white; margin-top: 25px; font-size: 14px">
              {{ MatchStats.match.matchStatus.name }}
            </h5>
          </div>
          <div class="col" style="text-align: center">
            <router-link
              id="routerLink"
              :to="{
                name: 'teamPage',
                params: { id: MatchStats.match.team2.id },
              }"
              ><img
                style="width: 90px; margin-top: 10px"
                :src="teamLogo + MatchStats.match.team2.id"
            /></router-link>
            <p style="color: white; margin-top: 50px">
              <span style="margin-left: 15px">
                {{ team2name | transliterate(cookiesObject.lang) }}
              </span>
              <img
                v-if="favs.some((fav) => fav.id === MatchStats.match.team2.id)"
                v-on:click="
                  removeFavorite({
                    value: MatchStats.match.team2.id,
                    type: team,
                  })
                "
                :src="favImage1"
                style="width: 15px; margin-bottom: 3px; cursor: pointer"
                alt=""
              />
              <img
                v-else
                v-on:click="
                  addToFavorites({
                    value: MatchStats.match.team2.id,
                    type: team,
                  })
                "
                :src="favImage"
                style="width: 15px; margin-bottom: 3px; cursor: pointer"
                alt=""
              />
            </p>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="MatchStats.match"
      class="Loc MobileShow"
      style="height: 100%; width: 100%"
    >
      <div
        v-if="MatchStats.match"
        style="
          background: #2c2d31;
          height: 45px;
          line-height: 3;
          font-size: 13px;
        "
      >
        <router-link
          style="color: lightgrey !important; text-decoration: none"
          id=""
          :to="{ name: 'LeaguePageNav', params: { leagueId: tournId } }"
          ><img
            :src="
              'https://sportapi.zuniac.com/tournament/logo/' +
              MatchStats.match.tournament.id
            "
            style="width: 30px; margin-left: 10px"
            alt=""
          />
          {{
            MatchStats.match.tournament.name | transliterate(cookiesObject.lang)
          }}
        </router-link>
        <span style="float: right; margin-right: 10px; color: lightgrey">
          {{
            MatchStats.match.matchTime.split(" ")[0]
              | transliterate(cookiesObject.lang)
          }}
        </span>
      </div>
      <b-container
        style="color: white; margin-top: 10px"
        class="bv-example-row bv-example-row-flex-cols"
      >
        <b-row align-v="center" style="text-align: center; margin-top: 30px">
          <b-col style="margin-bottom: 40px"
            ><router-link
              style=""
              id=""
              :to="{
                name: 'teamPage',
                params: { id: MatchStats.match.team1.id },
              }"
              ><img
                class=""
                style="width: 70px"
                :src="teamLogo + MatchStats.match.team1.id" /></router-link
          ></b-col>
          <b-col>
            <label
              :class="{ active: isActive }"
              class="toggle__button"
              style="margin-right: 11px"
            >
              <input
                v-on:change="setNot()"
                type="checkbox"
                v-model="checkedValue"
              />
              <span class="toggle__switch"></span>
            </label>
            <h3
              class="mobileScore"
              v-if="
                MatchStats.match.matchStatus.name == 'NS' ||
                MatchStats.match.matchStatus.name == 'POSTP' ||
                MatchStats.match.matchStatus.name == 'CANCL' ||
                MatchStats.match.matchStatus.name == 'TBA'
              "
              style=""
            >
              -
            </h3>
            <h3 class="mobileScore" v-else style="">
              {{
                MatchStats.match.currentScore
                  | transliterate(cookiesObject.lang)
              }}
            </h3>
            <p v-if="MatchStats.match.matchStatus.name == 'LIVE'">
              {{
                calculateMinutes(MatchStats.match.counterStartTime)
                  | transliterate(cookiesObject.lang)
              }}<img
                src="@/assets/redLight.gif"
                style="width: 5px; position: absolute; margin-top: 0px"
                alt="'"
              />
            </p>
            <p v-else-if="MatchStats.match.matchStatus.name == 'HT'">HT</p>
            <p v-else style="font-size: 12px">
              {{
                MatchStats.match.matchTime.split(" ")[1]
                  | transliterate(cookiesObject.lang)
              }}
            </p>
          </b-col>
          <b-col style="margin-bottom: 40px"
            ><router-link
              id=""
              :to="{
                name: 'teamPage',
                params: { id: MatchStats.match.team2.id },
              }"
              ><img
                class="logoImage"
                style="width: 70px"
                :src="teamLogo + MatchStats.match.team2.id"
            /></router-link>
            <br
          /></b-col>
        </b-row>
        <b-row
          style="text-align: center; font-size: 12px; padding-bottom: 20px"
        >
          <b-col style="margin-top: -30px">
            {{
              MatchStats.match.team1.name | transliterate(cookiesObject.lang)
            }}
            <br />
            <img
              v-if="favs.some((fav) => fav.id === MatchStats.match.team1.id)"
              v-on:click="
                removeFavorite({ value: MatchStats.match.team1.id, type: team })
              "
              :src="favImage1"
              style="
                width: 15px;
                margin-bottom: 3px;
                margin-top: 3px;
                cursor: pointer;
              "
              alt=""
            />
            <img
              v-else
              v-on:click="
                addToFavorites({ value: MatchStats.match.team1.id, type: team })
              "
              :src="favImage"
              style="
                width: 15px;
                margin-bottom: 3px;
                margin-top: 3px;
                cursor: pointer;
              "
              alt=""
            />
          </b-col>
          <b-col></b-col>
          <b-col style="margin-top: -30px">
            {{
              MatchStats.match.team2.name | transliterate(cookiesObject.lang)
            }}
            <br />
            <img
              v-if="favs.some((fav) => fav.id === MatchStats.match.team2.id)"
              v-on:click="
                removeFavorite({ value: MatchStats.match.team2.id, type: team })
              "
              :src="favImage1"
              style="
                width: 15px;
                margin-bottom: 3px;
                margin-top: 3px;
                cursor: pointer;
              "
              alt=""
            />
            <img
              v-else
              v-on:click="
                addToFavorites({ value: MatchStats.match.team2.id, type: team })
              "
              :src="favImage"
              style="
                width: 15px;
                margin-bottom: 3px;
                margin-top: 3px;
                cursor: pointer;
              "
              alt=""
            />
          </b-col>
        </b-row>
      </b-container>
    </div>

    <!-- Tabs -->
    <div style="border-radius: 0px; background: #212529">
      <b-tabs
        v-if="MatchStats.match"
        v-model="tabIndex"
        class="Some"
        style="border-radius: 0px; color: white; background: #2c2d31"
        nav-class="ks1"
        active-nav-item-class="ks"
        justified
      >
        <b-tab style="border-radius: 0px" lazy>
          <template v-slot:title>
            <img
              style="width: 20px"
              src="@/assets/matchpageNavbar/infoa.svg"
              v-if="tabIndex == 0"
            />
            <img
              style="width: 20px"
              src="@/assets/matchpageNavbar/info.svg"
              v-else
            />
            <br />
            <p
              style="
                margin: 0px;
                font-weight: 550;
                color: white;
                font-size: 12px;
              "
              v-if="tabIndex == 0"
            >
              {{ $t("LanguageEn.txtInfo") }}
            </p>
            <p
              style="
                margin: 0px;
                font-weight: 550;
                color: grey;
                font-size: 12px;
              "
              v-else
            >
              {{ $t("LanguageEn.txtInfo") }}
            </p>
          </template>
          <div
            class=""
            style="height: 12px !important; background: #141416 !important"
          ></div>

          <!-- Inner tabs -->

          <b-tabs
            class="Some"
            style="border-radius: 0px; color: white; background: #212225"
            nav-class="ks1"
            active-nav-item-class="ks"
            content-class="mt-0"
          >
            <b-tab>
              <template v-slot:title>
                <p
                  style="
                    margin: 0px;
                    font-weight: 550;
                    color: #e6e6e6;
                    font-size: 11px;
                  "
                >
                  {{ $t("LanguageEn.txtInfo") }}
                </p>
              </template>
              <div
                class=""
                style="height: 12px !important; background: #141416 !important"
              ></div>
              <li
                class="list-group-item"
                style="
                  border-radius: 0px;
                  background: #1a1a1d;
                  font-size: 13px;
                  text-align: center;
                "
                v-if="
                  MatchStats.match.events.length == 0 &&
                  MatchStats.match.tvStations.length == 0 &&
                  !MatchStats.match.venue
                "
              >
                <img
                  style="margin-bottom: 3px"
                  src="@/assets/noInfo.svg"
                  v-if="MatchStats.match.matchStatus.name == 'NS'"
                /><img
                  style="margin-bottom: 3px"
                  src="@/assets/noLine.svg"
                  v-else
                />
                {{ $t("LanguageEn.noInfo") }}
              </li>
              <li
                class="list-group-item listHeader"
                style="border-radius: 0px"
                v-else-if="
                  MatchStats.match.events.length == 0 &&
                  (MatchStats.match.tvStations.length != 0 ||
                    MatchStats.match.venue)
                "
              >
                <span v-if="MatchStats.match.tvStations.length != 0"
                  >{{ $t("LanguageEn.broadcast") }}
                </span>
                <span v-for="tv in MatchStats.match.tvStations" :key="tv"
                  >{{ tv | transliterate(cookiesObject.lang) }},
                </span>
                <span v-if="MatchStats.match.venue"
                  >{{ "Venue :" | transliterate(cookiesObject.lang) }}
                  {{
                    MatchStats.match.venue.name
                      | transliterate(cookiesObject.lang)
                  }}
                </span>
              </li>
              <div v-else style="">
                <div
                  v-if="MatchStats.match.events[0]"
                  style="font-size: 13.5px"
                  class="MobileHide"
                >
                  <li
                    class="list-group-item"
                    style="
                      border-radius: 0px;
                      background-color: #212225 !important;
                      color: white;
                      font-weight: 550;
                      font-size: 13px;
                    "
                  >
                    {{ $t("LanguageEn.matchSet1") }}
                  </li>
                  <div v-if="show1 > 0">
                    <div
                      class="container"
                      v-for="match in summedArray"
                      :key="match.id"
                    >
                      <div
                        class="row infoItem"
                        style="
                          background: #141416;
                          border-bottom: 1px solid #2c2d31;
                          line-height: 2.5;
                          font-size: 11px;
                        "
                        v-if="parseInt(match.eventTime) <= 45"
                      >
                        <div
                          class="col"
                          v-bind:class="{ team2: match.team == 'team2' }"
                        >
                          <span>
                            <span
                              v-if="match.team == 'team1'"
                              style="
                                margin-right: 2px;
                                font-weight: bold;
                                color: lightgrey;
                              "
                              >{{
                                parseInt(match.eventTime.slice(0, -3))
                                  | transliterate(cookiesObject.lang)
                              }}'
                              <span v-if="parseInt(match.extraTime) > 0">
                                +
                                {{
                                  parseInt(match.extraTime)
                                    | transliterate(cookiesObject.lang)
                                }}
                              </span>
                            </span>
                            <span
                              v-if="
                                match.videoPath &&
                                match.videoPath !== null &&
                                match.team == 'team2'
                              "
                            >
                              <img
                                @click="
                                  (vpath = match.videoPath),
                                    $refs['video-modal'].show()
                                "
                                src="@/assets/vid.svg"
                                style="
                                  width: 24px;
                                  cursor: pointer;
                                  margin-right: 2px;
                                "
                                alt=""
                            /></span>
                            <span v-if="match.team == 'team1'">
                              <img
                                style="width: 24px"
                                src="@/assets/yellowcardBig.png"
                                v-if="match.eventType == 'yellowcard'"
                              /><img
                                style="width: 24px"
                                src="@/assets/missed.png"
                                v-else-if="match.eventType == 'missed_penalty'"
                              /><img
                                style="width: 24px"
                                src="@/assets/goalBig.png"
                                v-else-if="match.eventType == 'goal'"
                              /><img
                                style="width: 24px"
                                src="@/assets/pGoal.svg"
                                v-else-if="match.eventType == 'penalty'"
                              /><img
                                style="width: 24px"
                                src="@/assets/redCardBig.png"
                                v-else-if="match.eventType == 'redcard'"
                              /><img
                                style="width: 24px"
                                src="@/assets/yellowred.png"
                                v-else-if="match.eventType == 'yellowred'"
                              /><img
                                v-else-if="match.eventType == 'var'"
                                style="width: 24px"
                                src="@/assets/varCancel.png"
                              />
                              <img
                                v-else-if="match.eventType == 'own-goal'"
                                style="width: 24px"
                                src="@/assets/ownGoal.png"
                              />
                              <img
                                v-else-if="match.eventType == 'substitution'"
                                style="width: 24px"
                                src="@/assets/subIn.png"
                              />
                              <span v-else>{{ match.eventType }}</span>
                            </span>
                            <span
                              v-if="
                                match.assistant &&
                                match.eventType == 'substitution' &&
                                match.team == 'team2'
                              "
                            >
                              <router-link
                                style="color: grey; text-decoration: none"
                                :to="{
                                  name: 'PlayerPage',
                                  params: { id: match.assistant.id },
                                }"
                              >
                                <span v-if="match.assistant.shortName">{{
                                  match.assistant.shortName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                                <span v-else>{{
                                  match.assistant.commonName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                              </router-link>
                              <img
                                style="width: 24px"
                                src="@/assets/subOut.png"
                              />
                            </span>
                            <span v-if="match.player">
                              <router-link
                                style="color: #e6e6e6; text-decoration: none"
                                :to="{
                                  name: 'PlayerPage',
                                  params: { id: match.player.id },
                                }"
                              >
                                <span v-if="match.player.shortName">{{
                                  match.player.shortName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                                <span v-else>{{
                                  match.player.commonName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                                <span
                                  v-if="
                                    match.eventType == 'goal' &&
                                    match.assistant !== null
                                  "
                                  style="color: grey; font-size: 9px"
                                >
                                  (<span v-if="match.assistant.shortName">{{
                                    match.assistant.shortName
                                      | transliterate(cookiesObject.lang)
                                  }}</span>
                                  <span v-else>{{
                                    match.assistant.commonName
                                      | transliterate(cookiesObject.lang)
                                  }}</span
                                  >)
                                </span>
                              </router-link>
                            </span>
                            <span v-if="match.team == 'team2'">
                              <img
                                style="width: 24px"
                                src="@/assets/yellowcardBig.png"
                                v-if="match.eventType == 'yellowcard'"
                              /><img
                                style="width: 24px"
                                src="@/assets/missed.png"
                                v-else-if="match.eventType == 'missed_penalty'"
                              /><img
                                style="width: 24px"
                                src="@/assets/goalBig.png"
                                v-else-if="match.eventType == 'goal'"
                              /><img
                                style="width: 24px"
                                src="@/assets/pGoal.svg"
                                v-else-if="match.eventType == 'penalty'"
                              /><img
                                style="width: 24px"
                                src="@/assets/redCardBig.png"
                                v-else-if="match.eventType == 'redcard'"
                              /><img
                                style="width: 24px"
                                src="@/assets/yellowred.png"
                                v-else-if="match.eventType == 'yellowred'"
                              /><img
                                v-else-if="match.eventType == 'var'"
                                style="width: 24px"
                                src="@/assets/varCancel.png"
                              />
                              <img
                                v-else-if="match.eventType == 'own-goal'"
                                style="width: 24px"
                                src="@/assets/ownGoal.png"
                              />
                              <img
                                v-else-if="match.eventType == 'substitution'"
                                style="width: 24px"
                                src="@/assets/subIn.png"
                              />
                              <span v-else>{{
                                match.eventType
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                            </span>
                            <span
                              v-if="
                                match.assistant &&
                                match.eventType == 'substitution' &&
                                match.team == 'team1'
                              "
                            >
                              <img
                                style="width: 24px"
                                src="@/assets/subOut.png"
                              />
                              <router-link
                                style="color: grey; text-decoration: none"
                                :to="{
                                  name: 'PlayerPage',
                                  params: { id: match.assistant.id },
                                }"
                              >
                                <span v-if="match.assistant.shortName">{{
                                  match.assistant.shortName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                                <span v-else>{{
                                  match.assistant.commonName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                              </router-link>
                            </span>
                            <span
                              v-if="
                                match.videoPath &&
                                match.videoPath !== null &&
                                match.team == 'team1'
                              "
                            >
                              <img
                                @click="
                                  (vpath = match.videoPath),
                                    $refs['video-modal'].show()
                                "
                                src="@/assets/vid.svg"
                                style="
                                  width: 24px;
                                  cursor: pointer;
                                  margin-right: 2px;
                                "
                                alt=""
                            /></span>
                            <span
                              v-if="match.team == 'team2'"
                              style="
                                margin-left: 2px;
                                font-weight: bold;
                                color: lightgrey;
                              "
                              >{{
                                parseInt(match.eventTime.slice(0, -3))
                                  | transliterate(cookiesObject.lang)
                              }}'
                              <span v-if="parseInt(match.extraTime) > 0">
                                +
                                {{
                                  parseInt(match.extraTime)
                                    | transliterate(cookiesObject.lang)
                                }}
                              </span></span
                            >
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <li
                      class="list-group-item"
                      style="
                        border-radius: 0px;
                        text-align: center;
                        background-color: #141416 !important;
                        color: white;
                        font-weight: 500;
                        font-size: 13px;
                      "
                    >
                      {{ $t("LanguageEn.noData") }}
                    </li>
                  </div>
                  <li
                    class="list-group-item"
                    style="
                      border-radius: 0px;
                      background-color: #212225 !important;
                      color: white;
                      font-weight: 550;
                      font-size: 13px;
                    "
                  >
                    {{ $t("LanguageEn.matchSet2") }}
                  </li>
                  <div v-if="show2 > 0">
                    <div
                      class="container"
                      v-for="match in summedArray"
                      :key="match.k"
                    >
                      <div
                        class="row infoItem"
                        style="
                          background: #141416;
                          border-bottom: 1px solid #2c2d31;
                          line-height: 2.5;
                          font-size: 11px;
                        "
                        v-if="parseInt(match.eventTime) > 45"
                      >
                        <div
                          class="col"
                          v-bind:class="{ team2: match.team == 'team2' }"
                        >
                          <span>
                            <span
                              v-if="match.team == 'team1'"
                              style="
                                margin-right: 2px;
                                font-weight: bold;
                                color: #e6e6e6;
                              "
                              >{{
                                parseInt(match.eventTime.slice(0, -3))
                                  | transliterate(cookiesObject.lang)
                              }}'
                              <span v-if="parseInt(match.extraTime) > 0">
                                +
                                {{
                                  parseInt(match.extraTime)
                                    | transliterate(cookiesObject.lang)
                                }}
                              </span></span
                            >
                            <span
                              v-if="
                                match.videoPath &&
                                match.videoPath !== null &&
                                match.team == 'team2'
                              "
                            >
                              <img
                                @click="
                                  (vpath = match.videoPath),
                                    $refs['video-modal'].show()
                                "
                                src="@/assets/vid.svg"
                                style="
                                  width: 24px;
                                  cursor: pointer;
                                  margin-right: 2px;
                                "
                                alt=""
                            /></span>
                            <span v-if="match.team == 'team1'">
                              <img
                                style="width: 24px"
                                src="@/assets/yellowcardBig.png"
                                v-if="match.eventType == 'yellowcard'"
                              /><img
                                style="width: 24px"
                                src="@/assets/missed.png"
                                v-else-if="match.eventType == 'missed_penalty'"
                              /><img
                                style="width: 24px"
                                src="@/assets/goalBig.png"
                                v-else-if="match.eventType == 'goal'"
                              /><img
                                style="width: 24px"
                                src="@/assets/pGoal.svg"
                                v-else-if="match.eventType == 'penalty'"
                              /><img
                                style="width: 24px"
                                src="@/assets/redCardBig.png"
                                v-else-if="match.eventType == 'redcard'"
                              /><img
                                style="width: 24px"
                                src="@/assets/yellowred.png"
                                v-else-if="match.eventType == 'yellowred'"
                              /><img
                                v-else-if="match.eventType == 'var'"
                                style="width: 24px"
                                src="@/assets/varCancel.png"
                              />
                              <img
                                v-else-if="match.eventType == 'own-goal'"
                                style="width: 24px"
                                src="@/assets/ownGoal.png"
                              />
                              <img
                                v-else-if="match.eventType == 'substitution'"
                                style="width: 24px"
                                src="@/assets/subIn.png"
                              />
                              <span v-else>{{
                                match.eventType
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                            </span>
                            <span
                              v-if="
                                match.assistant &&
                                match.eventType == 'substitution' &&
                                match.team == 'team2'
                              "
                              ><router-link
                                style="color: grey; text-decoration: none"
                                :to="{
                                  name: 'PlayerPage',
                                  params: { id: match.assistant.id },
                                }"
                              >
                                <span v-if="match.assistant.shortName">{{
                                  match.assistant.shortName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                                <span v-else>{{
                                  match.assistant.commonName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                              </router-link>
                              <img
                                style="width: 24px"
                                src="@/assets/subOut.png"
                            /></span>
                            <span v-if="match.player">
                              <router-link
                                style="color: #e6e6e6; text-decoration: none"
                                :to="{
                                  name: 'PlayerPage',
                                  params: { id: match.player.id },
                                }"
                              >
                                <span v-if="match.player.shortName">{{
                                  match.player.shortName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                                <span v-else>{{
                                  match.player.commonName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                                <span
                                  v-if="
                                    match.eventType == 'goal' &&
                                    match.assistant !== null
                                  "
                                  style="color: grey; font-size: 9px"
                                >
                                  (<span v-if="match.assistant.shortName">{{
                                    match.assistant.shortName
                                      | transliterate(cookiesObject.lang)
                                  }}</span>
                                  <span v-else>{{
                                    match.assistant.commonName
                                      | transliterate(cookiesObject.lang)
                                  }}</span
                                  >)
                                </span>
                              </router-link>
                            </span>
                            <span v-if="match.team == 'team2'">
                              <img
                                style="width: 24px"
                                src="@/assets/yellowcardBig.png"
                                v-if="match.eventType == 'yellowcard'"
                              /><img
                                style="width: 24px"
                                src="@/assets/missed.png"
                                v-else-if="match.eventType == 'missed_penalty'"
                              /><img
                                style="width: 24px"
                                src="@/assets/goalBig.png"
                                v-else-if="match.eventType == 'goal'"
                              /><img
                                style="width: 24px"
                                src="@/assets/pGoal.svg"
                                v-else-if="match.eventType == 'penalty'"
                              /><img
                                style="width: 24px"
                                src="@/assets/redCardBig.png"
                                v-else-if="match.eventType == 'redcard'"
                              /><img
                                style="width: 24px"
                                src="@/assets/yellowred.png"
                                v-else-if="match.eventType == 'yellowred'"
                              /><img
                                v-else-if="match.eventType == 'var'"
                                style="width: 24px"
                                src="@/assets/varCancel.png"
                              />
                              <img
                                v-else-if="match.eventType == 'own-goal'"
                                style="width: 24px"
                                src="@/assets/ownGoal.png"
                              />
                              <img
                                v-else-if="match.eventType == 'substitution'"
                                style="width: 24px"
                                src="@/assets/subIn.png"
                              />
                              <span v-else>{{
                                match.eventType
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                            </span>
                            <span
                              v-if="
                                match.assistant &&
                                match.eventType == 'substitution' &&
                                match.team == 'team1'
                              "
                            >
                              <img
                                style="width: 24px"
                                src="@/assets/subOut.png"
                              />
                              <router-link
                                style="color: grey; text-decoration: none"
                                :to="{
                                  name: 'PlayerPage',
                                  params: { id: match.assistant.id },
                                }"
                              >
                                <span v-if="match.assistant.shortName">{{
                                  match.assistant.shortName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                                <span v-else>{{
                                  match.assistant.commonName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                              </router-link>
                            </span>
                            <span
                              v-if="
                                match.videoPath &&
                                match.videoPath !== null &&
                                match.team == 'team1'
                              "
                            >
                              <img
                                @click="
                                  (vpath = match.videoPath),
                                    $refs['video-modal'].show()
                                "
                                src="@/assets/vid.svg"
                                style="
                                  width: 24px;
                                  cursor: pointer;
                                  margin-right: 2px;
                                "
                                alt=""
                            /></span>
                            <span
                              v-if="match.team == 'team2'"
                              style="
                                margin-left: 2px;
                                font-weight: bold;
                                color: lightgrey;
                              "
                              >{{
                                parseInt(match.eventTime.slice(0, -3))
                                  | transliterate(cookiesObject.lang)
                              }}'
                              <span v-if="parseInt(match.extraTime) > 0">
                                +
                                {{
                                  parseInt(match.extraTime)
                                    | transliterate(cookiesObject.lang)
                                }}
                              </span></span
                            >
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <li
                      class="list-group-item"
                      style="
                        border-radius: 0px;
                        text-align: center;
                        background-color: #141416 !important;
                        color: white;
                        font-weight: 500;
                        font-size: 13px;
                      "
                    >
                      {{ $t("LanguageEn.noData") }}
                    </li>
                  </div>
                  <div v-if="penArray.length > 0">
                    <li
                      class="list-group-item"
                      style="
                        border-radius: 0px;
                        background-color: #212225 !important;
                        color: white;
                        font-weight: 550;
                        font-size: 13px;
                      "
                    >
                      Penalty
                    </li>
                    <div
                      class="container"
                      v-for="match in penArray"
                      :key="match.k"
                    >
                      <div
                        class="row infoItem"
                        style="
                          background: #141416;
                          border-bottom: 1px solid #2c2d31;
                          line-height: 2.5;
                          font-size: 11px;
                        "
                      >
                        <div
                          class="col"
                          v-bind:class="{ team2: match.team == 'team2' }"
                        >
                          <span>
                            <span
                              v-if="match.team == 'team1'"
                              style="
                                margin-right: 2px;
                                font-weight: bold;
                                color: #e6e6e6;
                              "
                              >{{
                                parseInt(match.eventTime.slice(0, -3))
                                  | transliterate(cookiesObject.lang)
                              }}'
                              <span v-if="parseInt(match.extraTime) > 0">
                                +
                                {{
                                  parseInt(match.extraTime)
                                    | transliterate(cookiesObject.lang)
                                }}
                              </span></span
                            >
                            <span v-if="match.team == 'team1'">
                              <img
                                style="width: 24px"
                                src="@/assets/goalBig.png"
                                v-if="match.eventType == 'pen_shootout_goal'"
                              /><img
                                style="width: 24px"
                                src="@/assets/missed.png"
                                v-else-if="
                                  match.eventType == 'pen_shootout_miss'
                                "
                              /><span v-else>{{
                                match.eventType
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                            </span>
                            <span
                              v-if="
                                match.assistant &&
                                match.eventType == 'substitution' &&
                                match.team == 'team2'
                              "
                              ><router-link
                                style="color: grey; text-decoration: none"
                                :to="{
                                  name: 'PlayerPage',
                                  params: { id: match.assistant.id },
                                }"
                              >
                                <span v-if="match.assistant.shortName">{{
                                  match.assistant.shortName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                                <span v-else>{{
                                  match.assistant.commonName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                              </router-link>
                              <img
                                style="width: 24px"
                                src="@/assets/subOut.png"
                            /></span>
                            <span v-if="match.player">
                              <router-link
                                style="color: #e6e6e6; text-decoration: none"
                                :to="{
                                  name: 'PlayerPage',
                                  params: { id: match.player.id },
                                }"
                              >
                                <span v-if="match.player.shortName">{{
                                  match.player.shortName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                                <span v-else>{{
                                  match.player.commonName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                                <span
                                  v-if="
                                    match.eventType == 'goal' &&
                                    match.assistant !== null
                                  "
                                  style="color: grey; font-size: 9px"
                                >
                                  (<span v-if="match.assistant.shortName">{{
                                    match.assistant.shortName
                                      | transliterate(cookiesObject.lang)
                                  }}</span>
                                  <span v-else>{{
                                    match.assistant.commonName
                                      | transliterate(cookiesObject.lang)
                                  }}</span
                                  >)
                                </span>
                              </router-link>
                            </span>
                            <span v-if="match.team == 'team2'">
                              <img
                                style="width: 24px"
                                src="@/assets/goalBig.png"
                                v-if="match.eventType == 'pen_shootout_goal'"
                              /><img
                                style="width: 24px"
                                src="@/assets/missed.png"
                                v-else-if="
                                  match.eventType == 'pen_shootout_miss'
                                "
                              /><span v-else>{{
                                match.eventType
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                            </span>
                            <span
                              v-if="match.team == 'team2'"
                              style="
                                margin-left: 2px;
                                font-weight: bold;
                                color: lightgrey;
                              "
                              >{{
                                parseInt(match.eventTime.slice(0, -3))
                                  | transliterate(cookiesObject.lang)
                              }}'
                              <span v-if="parseInt(match.extraTime) > 0">
                                +
                                {{
                                  parseInt(match.extraTime)
                                    | transliterate(cookiesObject.lang)
                                }}
                              </span></span
                            >
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="MatchStats.match.referee && MatchStats.match.venue"
                    style="background: #212226"
                  >
                    <li
                      class="list-group-item"
                      style="
                        border-radius: 0px;
                        text-align: left;
                        background: #212225;
                      "
                    >
                      {{ $t("LanguageEn.txtReferee") }} /
                      {{ $t("LanguageEn.txtStadium") }}
                    </li>
                    <li
                      class="list-group-item referee"
                      v-if="
                        MatchStats.match.referee.name &&
                        MatchStats.match.venue.name
                      "
                    >
                      <span style="font-weight: bold"
                        >{{ $t("LanguageEn.txtReferee") }}:</span
                      >
                      {{
                        MatchStats.match.referee.name
                          | transliterate(cookiesObject.lang)
                      }}
                      <span style="font-weight: bold; margin-left: 10px"
                        >{{ $t("LanguageEn.txtStadium") }}:</span
                      >
                      {{
                        MatchStats.match.venue.name
                          | transliterate(cookiesObject.lang)
                      }}
                    </li>
                    <li
                      class="list-group-item referee"
                      v-if="MatchStats.match.tvStations.length !== 0"
                    >
                      {{ $t("LanguageEn.broadcast") }}:
                      <span v-if="MatchStats.match.tvStations[0]"
                        >{{
                          MatchStats.match.tvStations[0]
                            | transliterate(cookiesObject.lang)
                        }},</span
                      >
                      <span v-if="MatchStats.match.tvStations[1]"
                        >{{
                          MatchStats.match.tvStations[1]
                            | transliterate(cookiesObject.lang)
                        }},</span
                      >
                      <span
                        @click="$refs['tv-modal'].show()"
                        style="
                          text-decoration: underline;
                          cursor: pointer;
                          color: #1a7bfb;
                        "
                      >
                        {{ "More:" | transliterate(cookiesObject.lang) }}</span
                      >
                    </li>
                    <b-modal
                      ref="tv-modal"
                      size="md"
                      hide-footer
                      centered
                      title="TV Stations:"
                    >
                      <ul style="list-style-type: none">
                        <li
                          v-for="sing in MatchStats.match.tvStations"
                          :key="sing.id"
                        >
                          {{ sing | transliterate(cookiesObject.lang) }}
                        </li>
                      </ul>
                    </b-modal>
                  </div>
                </div>
              </div>
              <div>
                <div
                  v-if="MatchStats.match.events[0]"
                  style="font-size: 13.5px"
                  class="MobileShow"
                >
                  <li
                    class="list-group-item"
                    style="
                      border-radius: 0px;
                      background-color: #212225 !important;
                      color: white;
                      font-weight: 550;
                      font-size: 13px;
                    "
                  >
                    {{ $t("LanguageEn.matchSet1") }}
                  </li>
                  <div v-if="show1 > 0">
                    <div
                      class="container"
                      v-for="match in summedArray"
                      :key="match.id"
                    >
                      <div
                        class="row infoItem"
                        style="
                          background: #141416;
                          border-bottom: 1px solid #2c2d31;
                          line-height: 2.5;
                          font-size: 11px;
                        "
                        v-if="parseInt(match.eventTime) <= 45"
                      >
                        <div
                          class="col"
                          v-bind:class="{ team2: match.team == 'team2' }"
                        >
                          <span>
                            <span
                              v-if="match.team == 'team1'"
                              style="
                                margin-right: 2px;
                                font-weight: bold;
                                color: lightgrey;
                              "
                              >{{
                                parseInt(match.eventTime.slice(0, -3))
                                  | transliterate(cookiesObject.lang)
                              }}'
                              <span v-if="parseInt(match.extraTime) > 0">
                                +
                                {{
                                  parseInt(match.extraTime)
                                    | transliterate(cookiesObject.lang)
                                }}
                              </span></span
                            >
                            <span
                              v-if="
                                match.videoPath &&
                                match.videoPath !== null &&
                                match.team == 'team2'
                              "
                            >
                              <img
                                @click="
                                  (vpath = match.videoPath),
                                    $refs['video-modal'].show()
                                "
                                src="@/assets/vid.svg"
                                style="
                                  width: 24px;
                                  cursor: pointer;
                                  margin-right: 2px;
                                "
                                alt=""
                            /></span>
                            <span v-if="match.team == 'team1'">
                              <img
                                style="width: 24px"
                                src="@/assets/yellowcardBig.png"
                                v-if="match.eventType == 'yellowcard'"
                              /><img
                                style="width: 24px"
                                src="@/assets/missed.png"
                                v-else-if="match.eventType == 'missed_penalty'"
                              /><img
                                style="width: 24px"
                                src="@/assets/goalBig.png"
                                v-else-if="match.eventType == 'goal'"
                              /><img
                                style="width: 24px"
                                src="@/assets/pGoal.svg"
                                v-else-if="match.eventType == 'penalty'"
                              /><img
                                style="width: 24px"
                                src="@/assets/redCardBig.png"
                                v-else-if="match.eventType == 'redcard'"
                              /><img
                                style="width: 24px"
                                src="@/assets/yellowred.png"
                                v-else-if="match.eventType == 'yellowred'"
                              /><img
                                v-else-if="match.eventType == 'var'"
                                style="width: 24px"
                                src="@/assets/varCancel.png"
                              />
                              <img
                                v-else-if="match.eventType == 'own-goal'"
                                style="width: 24px"
                                src="@/assets/ownGoal.png"
                              />
                              <img
                                v-else-if="match.eventType == 'substitution'"
                                style="width: 24px"
                                src="@/assets/subIn.png"
                              />
                              <span v-else>{{
                                match.eventType
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                            </span>
                            <span
                              v-if="
                                match.assistant &&
                                match.eventType == 'substitution' &&
                                match.team == 'team2'
                              "
                            >
                              <router-link
                                style="color: grey; text-decoration: none"
                                :to="{
                                  name: 'PlayerPage',
                                  params: { id: match.assistant.id },
                                }"
                              >
                                <span v-if="match.assistant.shortName">{{
                                  match.assistant.shortName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                                <span v-else>{{
                                  match.assistant.commonName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                              </router-link>
                              <img
                                style="width: 24px"
                                src="@/assets/subOut.png"
                              />
                            </span>
                            <span v-if="match.player">
                              <router-link
                                style="color: #e6e6e6; text-decoration: none"
                                :to="{
                                  name: 'PlayerPage',
                                  params: { id: match.player.id },
                                }"
                              >
                                <span v-if="match.player.shortName">{{
                                  match.player.shortName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                                <span v-else>{{
                                  match.player.commonName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                                <span
                                  v-if="
                                    match.eventType == 'goal' &&
                                    match.assistant !== null
                                  "
                                  style="color: grey; font-size: 9px"
                                >
                                  (<span v-if="match.assistant.shortName">{{
                                    match.assistant.shortName
                                      | transliterate(cookiesObject.lang)
                                  }}</span>
                                  <span v-else>{{
                                    match.assistant.commonName
                                      | transliterate(cookiesObject.lang)
                                  }}</span
                                  >)
                                </span>
                              </router-link>
                            </span>
                            <span v-if="match.team == 'team2'">
                              <img
                                style="width: 24px"
                                src="@/assets/yellowcardBig.png"
                                v-if="match.eventType == 'yellowcard'"
                              /><img
                                style="width: 24px"
                                src="@/assets/missed.png"
                                v-else-if="match.eventType == 'missed_penalty'"
                              /><img
                                style="width: 24px"
                                src="@/assets/goalBig.png"
                                v-else-if="match.eventType == 'goal'"
                              /><img
                                style="width: 24px"
                                src="@/assets/pGoal.svg"
                                v-else-if="match.eventType == 'penalty'"
                              /><img
                                style="width: 24px"
                                src="@/assets/redCardBig.png"
                                v-else-if="match.eventType == 'redcard'"
                              /><img
                                style="width: 24px"
                                src="@/assets/yellowred.png"
                                v-else-if="match.eventType == 'yellowred'"
                              /><img
                                v-else-if="match.eventType == 'var'"
                                style="width: 24px"
                                src="@/assets/varCancel.png"
                              />
                              <img
                                v-else-if="match.eventType == 'own-goal'"
                                style="width: 24px"
                                src="@/assets/ownGoal.png"
                              />
                              <img
                                v-else-if="match.eventType == 'substitution'"
                                style="width: 24px"
                                src="@/assets/subIn.png"
                              />
                              <span v-else>{{
                                match.eventType
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                            </span>
                            <span
                              v-if="
                                match.assistant &&
                                match.eventType == 'substitution' &&
                                match.team == 'team1'
                              "
                            >
                              <img
                                style="width: 24px"
                                src="@/assets/subOut.png"
                              />
                              <router-link
                                style="color: grey; text-decoration: none"
                                :to="{
                                  name: 'PlayerPage',
                                  params: { id: match.assistant.id },
                                }"
                              >
                                <span v-if="match.assistant.shortName">{{
                                  match.assistant.shortName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                                <span v-else>{{
                                  match.assistant.commonName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                              </router-link>
                            </span>
                            <span
                              v-if="
                                match.videoPath &&
                                match.videoPath !== null &&
                                match.team == 'team1'
                              "
                            >
                              <img
                                @click="
                                  (vpath = match.videoPath),
                                    $refs['video-modal'].show()
                                "
                                src="@/assets/vid.svg"
                                style="
                                  width: 24px;
                                  cursor: pointer;
                                  margin-right: 2px;
                                "
                                alt=""
                            /></span>
                            <span
                              v-if="match.team == 'team2'"
                              style="
                                margin-left: 2px;
                                font-weight: bold;
                                color: lightgrey;
                              "
                              >{{
                                parseInt(match.eventTime.slice(0, -3))
                                  | transliterate(cookiesObject.lang)
                              }}'
                              <span v-if="parseInt(match.extraTime) > 0">
                                +
                                {{
                                  parseInt(match.extraTime)
                                    | transliterate(cookiesObject.lang)
                                }}
                              </span></span
                            >
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <li
                      class="list-group-item"
                      style="
                        border-radius: 0px;
                        text-align: center;
                        background-color: #141416 !important;
                        color: white;
                        font-weight: 500;
                        font-size: 13px;
                      "
                    >
                      {{ $t("LanguageEn.noData") }}
                    </li>
                  </div>
                  <li
                    class="list-group-item"
                    style="
                      border-radius: 0px;
                      background-color: #212225 !important;
                      color: white;
                      font-weight: 550;
                      font-size: 13px;
                    "
                  >
                    {{ $t("LanguageEn.matchSet2") }}
                  </li>
                  <div v-if="show2 > 0">
                    <div
                      class="container"
                      v-for="match in summedArray"
                      :key="match.k"
                    >
                      <div
                        class="row infoItem"
                        style="
                          background: #141416;
                          border-bottom: 1px solid #2c2d31;
                          line-height: 2.5;
                          font-size: 11px;
                        "
                        v-if="parseInt(match.eventTime) > 45"
                      >
                        <div
                          class="col"
                          v-bind:class="{ team2: match.team == 'team2' }"
                        >
                          <span>
                            <span
                              v-if="match.team == 'team1'"
                              style="
                                margin-right: 2px;
                                font-weight: bold;
                                color: #e6e6e6;
                              "
                              >{{
                                parseInt(match.eventTime.slice(0, -3))
                                  | transliterate(cookiesObject.lang)
                              }}'
                              <span v-if="parseInt(match.extraTime) > 0">
                                +
                                {{
                                  parseInt(match.extraTime)
                                    | transliterate(cookiesObject.lang)
                                }}
                              </span></span
                            >
                            <span
                              v-if="
                                match.videoPath &&
                                match.videoPath !== null &&
                                match.team == 'team2'
                              "
                            >
                              <img
                                @click="
                                  (vpath = match.videoPath),
                                    $refs['video-modal'].show()
                                "
                                src="@/assets/vid.svg"
                                style="
                                  width: 24px;
                                  cursor: pointer;
                                  margin-right: 2px;
                                "
                                alt=""
                            /></span>
                            <span v-if="match.team == 'team1'">
                              <img
                                style="width: 24px"
                                src="@/assets/yellowcardBig.png"
                                v-if="match.eventType == 'yellowcard'"
                              /><img
                                style="width: 24px"
                                src="@/assets/missed.png"
                                v-else-if="match.eventType == 'missed_penalty'"
                              /><img
                                style="width: 24px"
                                src="@/assets/goalBig.png"
                                v-else-if="match.eventType == 'goal'"
                              /><img
                                style="width: 24px"
                                src="@/assets/pGoal.svg"
                                v-else-if="match.eventType == 'penalty'"
                              /><img
                                style="width: 24px"
                                src="@/assets/redCardBig.png"
                                v-else-if="match.eventType == 'redcard'"
                              /><img
                                style="width: 24px"
                                src="@/assets/yellowred.png"
                                v-else-if="match.eventType == 'yellowred'"
                              /><img
                                v-else-if="match.eventType == 'var'"
                                style="width: 24px"
                                src="@/assets/varCancel.png"
                              />
                              <img
                                v-else-if="match.eventType == 'own-goal'"
                                style="width: 24px"
                                src="@/assets/ownGoal.png"
                              />
                              <img
                                v-else-if="match.eventType == 'substitution'"
                                style="width: 24px"
                                src="@/assets/subIn.png"
                              />
                              <span v-else>{{
                                match.eventType
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                            </span>
                            <span
                              v-if="
                                match.assistant &&
                                match.eventType == 'substitution' &&
                                match.team == 'team2'
                              "
                              ><router-link
                                style="color: grey; text-decoration: none"
                                :to="{
                                  name: 'PlayerPage',
                                  params: { id: match.assistant.id },
                                }"
                              >
                                <span v-if="match.assistant.shortName">{{
                                  match.assistant.shortName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                                <span v-else>{{
                                  match.assistant.commonName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                              </router-link>
                              <img
                                style="width: 24px"
                                src="@/assets/subOut.png"
                            /></span>
                            <span v-if="match.player">
                              <router-link
                                style="color: #e6e6e6; text-decoration: none"
                                :to="{
                                  name: 'PlayerPage',
                                  params: { id: match.player.id },
                                }"
                              >
                                <span v-if="match.player.shortName">{{
                                  match.player.shortName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                                <span v-else>{{
                                  match.player.commonName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                                <span
                                  v-if="
                                    match.eventType == 'goal' &&
                                    match.assistant !== null
                                  "
                                  style="color: grey; font-size: 9px"
                                >
                                  (<span v-if="match.assistant.shortName">{{
                                    match.assistant.shortName
                                      | transliterate(cookiesObject.lang)
                                  }}</span>
                                  <span v-else>{{
                                    match.assistant.commonName
                                      | transliterate(cookiesObject.lang)
                                  }}</span
                                  >)
                                </span>
                              </router-link>
                            </span>
                            <span v-if="match.team == 'team2'">
                              <img
                                style="width: 24px"
                                src="@/assets/yellowcardBig.png"
                                v-if="match.eventType == 'yellowcard'"
                              /><img
                                style="width: 24px"
                                src="@/assets/missed.png"
                                v-else-if="match.eventType == 'missed_penalty'"
                              /><img
                                style="width: 24px"
                                src="@/assets/goalBig.png"
                                v-else-if="match.eventType == 'goal'"
                              /><img
                                style="width: 24px"
                                src="@/assets/pGoal.svg"
                                v-else-if="match.eventType == 'penalty'"
                              /><img
                                style="width: 24px"
                                src="@/assets/redCardBig.png"
                                v-else-if="match.eventType == 'redcard'"
                              /><img
                                style="width: 24px"
                                src="@/assets/yellowred.png"
                                v-else-if="match.eventType == 'yellowred'"
                              /><img
                                v-else-if="match.eventType == 'var'"
                                style="width: 24px"
                                src="@/assets/varCancel.png"
                              />
                              <img
                                v-else-if="match.eventType == 'own-goal'"
                                style="width: 24px"
                                src="@/assets/ownGoal.png"
                              />
                              <img
                                v-else-if="match.eventType == 'substitution'"
                                style="width: 24px"
                                src="@/assets/subIn.png"
                              />
                              <span v-else>{{
                                match.eventType
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                            </span>
                            <span
                              v-if="
                                match.assistant &&
                                match.eventType == 'substitution' &&
                                match.team == 'team1'
                              "
                            >
                              <img
                                style="width: 24px"
                                src="@/assets/subOut.png"
                              />
                              <router-link
                                style="color: grey; text-decoration: none"
                                :to="{
                                  name: 'PlayerPage',
                                  params: { id: match.assistant.id },
                                }"
                              >
                                <span v-if="match.assistant.shortName">{{
                                  match.assistant.shortName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                                <span v-else>{{
                                  match.assistant.commonName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                              </router-link>
                            </span>
                            <span
                              v-if="
                                match.videoPath &&
                                match.videoPath !== null &&
                                match.team == 'team1'
                              "
                            >
                              <img
                                @click="
                                  (vpath = match.videoPath),
                                    $refs['video-modal'].show()
                                "
                                src="@/assets/vid.svg"
                                style="
                                  width: 24px;
                                  cursor: pointer;
                                  margin-right: 2px;
                                "
                                alt=""
                            /></span>
                            <span
                              v-if="match.team == 'team2'"
                              style="
                                margin-left: 2px;
                                font-weight: bold;
                                color: lightgrey;
                              "
                              >{{ parseInt(match.eventTime.slice(0, -3)) }}'
                              <span v-if="parseInt(match.extraTime) > 0">
                                + {{ parseInt(match.extraTime) }}
                              </span></span
                            >
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <li
                      class="list-group-item"
                      style="
                        border-radius: 0px;
                        text-align: center;
                        background-color: #141416 !important;
                        color: white;
                        font-weight: 500;
                        font-size: 13px;
                      "
                    >
                      {{ $t("LanguageEn.noData") }}
                    </li>
                  </div>
                  <div v-if="penArray.length > 0">
                    <li
                      class="list-group-item"
                      style="
                        border-radius: 0px;
                        background-color: #212225 !important;
                        color: white;
                        font-weight: 550;
                        font-size: 13px;
                      "
                    >
                      Penalty
                    </li>
                    <div
                      class="container"
                      v-for="match in penArray"
                      :key="match.k"
                    >
                      <div
                        class="row infoItem"
                        style="
                          background: #141416;
                          border-bottom: 1px solid #2c2d31;
                          line-height: 2.5;
                          font-size: 11px;
                        "
                      >
                        <div
                          class="col"
                          v-bind:class="{ team2: match.team == 'team2' }"
                        >
                          <span>
                            <span
                              v-if="match.team == 'team1'"
                              style="
                                margin-right: 2px;
                                font-weight: bold;
                                color: #e6e6e6;
                              "
                              >{{
                                parseInt(match.eventTime.slice(0, -3))
                                  | transliterate(cookiesObject.lang)
                              }}'
                              <span v-if="parseInt(match.extraTime) > 0">
                                +
                                {{
                                  parseInt(match.extraTime)
                                    | transliterate(cookiesObject.lang)
                                }}
                              </span></span
                            >
                            <span v-if="match.team == 'team1'">
                              <img
                                style="width: 24px"
                                src="@/assets/goalBig.png"
                                v-if="match.eventType == 'pen_shootout_goal'"
                              /><img
                                style="width: 24px"
                                src="@/assets/missed.png"
                                v-else-if="
                                  match.eventType == 'pen_shootout_miss'
                                "
                              /><span v-else>{{
                                match.eventType
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                            </span>
                            <span
                              v-if="
                                match.assistant &&
                                match.eventType == 'substitution' &&
                                match.team == 'team2'
                              "
                              ><router-link
                                style="color: grey; text-decoration: none"
                                :to="{
                                  name: 'PlayerPage',
                                  params: { id: match.assistant.id },
                                }"
                              >
                                <span v-if="match.assistant.shortName">{{
                                  match.assistant.shortName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                                <span v-else>{{
                                  match.assistant.commonName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                              </router-link>
                              <img
                                style="width: 24px"
                                src="@/assets/subOut.png"
                            /></span>
                            <span v-if="match.player">
                              <router-link
                                style="color: #e6e6e6; text-decoration: none"
                                :to="{
                                  name: 'PlayerPage',
                                  params: { id: match.player.id },
                                }"
                              >
                                <span v-if="match.player.shortName">{{
                                  match.player.shortName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                                <span v-else>{{
                                  match.player.commonName
                                    | transliterate(cookiesObject.lang)
                                }}</span>
                                <span
                                  v-if="
                                    match.eventType == 'goal' &&
                                    match.assistant !== null
                                  "
                                  style="color: grey; font-size: 9px"
                                >
                                  (<span v-if="match.assistant.shortName">{{
                                    match.assistant.shortName
                                      | transliterate(cookiesObject.lang)
                                  }}</span>
                                  <span v-else>{{
                                    match.assistant.commonName
                                      | transliterate(cookiesObject.lang)
                                  }}</span
                                  >)
                                </span>
                              </router-link>
                            </span>
                            <span v-if="match.team == 'team2'">
                              <img
                                style="width: 24px"
                                src="@/assets/goalBig.png"
                                v-if="match.eventType == 'pen_shootout_goal'"
                              /><img
                                style="width: 24px"
                                src="@/assets/missed.png"
                                v-else-if="
                                  match.eventType == 'pen_shootout_miss'
                                "
                              /><span v-else>{{
                                match.eventType
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                            </span>
                            <span
                              v-if="match.team == 'team2'"
                              style="
                                margin-left: 2px;
                                font-weight: bold;
                                color: lightgrey;
                              "
                              >{{
                                parseInt(match.eventTime.slice(0, -3))
                                  | transliterate(cookiesObject.lang)
                              }}'
                              <span v-if="parseInt(match.extraTime) > 0">
                                +
                                {{
                                  parseInt(match.extraTime)
                                    | transliterate(cookiesObject.lang)
                                }}
                              </span></span
                            >
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="MatchStats.match.referee && MatchStats.match.venue"
                    style="background: #212226"
                  >
                    <li
                      class="list-group-item"
                      style="
                        border-radius: 0px;
                        text-align: left;
                        background: #212225;
                      "
                    >
                      {{ $t("LanguageEn.txtReferee") }} /
                      {{ $t("LanguageEn.txtStadium") }}
                    </li>
                    <li
                      class="list-group-item referee"
                      v-if="
                        MatchStats.match.referee.name &&
                        MatchStats.match.venue.name
                      "
                    >
                      <span style="font-weight: bold"
                        >{{ $t("LanguageEn.txtReferee") }}:</span
                      >
                      {{
                        MatchStats.match.referee.name
                          | transliterate(cookiesObject.lang)
                      }}
                      <span style="font-weight: bold; margin-left: 10px"
                        >{{ $t("LanguageEn.txtStadium") }}:</span
                      >
                      {{
                        MatchStats.match.venue.name
                          | transliterate(cookiesObject.lang)
                      }}
                    </li>
                    <li
                      class="list-group-item referee"
                      v-if="MatchStats.match.tvStations.length !== 0"
                    >
                      {{ $t("LanguageEn.broadcast") }}
                      <span v-if="MatchStats.match.tvStations[0]"
                        >{{
                          MatchStats.match.tvStations[0]
                            | transliterate(cookiesObject.lang)
                        }},</span
                      >
                      <span v-if="MatchStats.match.tvStations[1]"
                        >{{
                          MatchStats.match.tvStations[1]
                            | transliterate(cookiesObject.lang)
                        }},</span
                      >
                      <span
                        @click="$refs['tv-modal'].show()"
                        style="
                          text-decoration: underline;
                          cursor: pointer;
                          color: #1a7bfb;
                        "
                      >
                        More</span
                      >
                    </li>
                    <b-modal
                      ref="tv-modal"
                      size="md"
                      hide-footer
                      centered
                      title="TV Stations:"
                    >
                      <ul style="list-style-type: none">
                        <li
                          v-for="sing in MatchStats.match.tvStations"
                          :key="sing.id"
                        >
                          {{ sing | transliterate(cookiesObject.lang) }}
                        </li>
                      </ul>
                    </b-modal>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <p
                  style="
                    margin: 0px;
                    font-weight: 550;
                    color: #e6e6e6;
                    font-size: 11px;
                  "
                >
                  {{ $t("LanguageEn.txtLineUp") }}
                </p>
              </template>
              <div
                class=""
                style="height: 12px !important; background: #141416 !important"
              ></div>
              <li
                v-if="team1F == null"
                class="list-group-item"
                style="
                  border-radius: 0px;
                  background: #1a1a1d;
                  font-size: 11px;
                  text-align: center;
                "
              >
                <img style="margin-bottom: 3px" src="@/assets/noInfo.svg" />{{
                  $t("LanguageEn.noInfo")
                }}
              </li>
              <div v-else>
                <b-tabs
                  content-class="mt-0"
                  align="center"
                  nav-class="ks41"
                  style="background: #1a1a1c"
                  active-nav-item-class="ks4"
                  v-if="team1F !== null"
                >
                  <div
                    class=""
                    style="
                      height: 12px !important;
                      background: #141416 !important;
                    "
                  ></div>
                  <b-tab>
                    <template v-slot:title>
                      <p
                        style="
                          margin: 0px;
                          font-weight: 550;
                          color: #e6e6e6;
                          font-size: 11px;
                        "
                      >
                        {{ team1name | transliterate(cookiesObject.lang) }}
                      </p>
                    </template>
                    <div v-if="team1F == 3" class="fF container">
                      <b-container
                        class="bv-example-row bv-example-row-flex-cols Fnames"
                        style="text-align: center; padding-top: 20px"
                      >
                        <b-row
                          class="rCl"
                          align-v="start"
                          style="height: 100px"
                        >
                          <b-col
                            v-for="player in attArr"
                            :key="player.id"
                            class="pl-0 pr-0"
                          >
                            <sup
                              v-for="event in summedArray"
                              :key="event.id"
                              style="
                                background: black;
                                padding-bottom: 5px;
                                padding-top: 3px;
                                border-radius: 50%;
                              "
                            >
                              <span v-if="event.player !== null">
                                <span
                                  v-if="player.player.id == event.player.id"
                                >
                                  <img
                                    style="width: 20px"
                                    src="@/assets/yellowcardBig.png"
                                    v-if="event.eventType == 'yellowcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/missed.png"
                                    v-else-if="
                                      event.eventType == 'missed_penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/goalBig.png"
                                    v-else-if="
                                      event.eventType == 'goal' ||
                                      event.eventType == 'penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/redCardBig.png"
                                    v-else-if="event.eventType == 'redcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/yellowred.png"
                                    v-else-if="event.eventType == 'yellowred'"
                                  /><img
                                    v-else-if="event.eventType == 'var'"
                                    style="width: 20px"
                                    src="@/assets/varCancel.png"
                                  />
                                  <img
                                    v-else-if="event.eventType == 'own-goal'"
                                    style="width: 20px"
                                    src="@/assets/ownGoal.png"
                                  />
                                  <img
                                    v-else-if="
                                      event.eventType == 'substitution'
                                    "
                                    style="width: 20px"
                                    src="@/assets/subIn.png"
                                  />
                                  <span v-else>{{
                                    event.eventType
                                      | transliterate(cookiesObject.lang)
                                  }}</span>
                                </span>
                              </span>
                            </sup>
                            <br />
                            <img
                              :src="playerLogo + player.player.id"
                              class="plImage"
                              alt=""
                              style="background: #e6e6e6; border-radius: 50%"
                            />
                            <br />
                            <span
                              style="
                                background: #1a1a1d;
                                border-radius: 5px;
                                font-size: 10px;
                                padding: 2px;
                              "
                            >
                              <span v-if="player.player.shortName">{{
                                player.player.shortName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                              <span v-else>{{
                                player.player.commonName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                            </span>
                          </b-col>
                        </b-row>

                        <b-row
                          class="rCl"
                          align-v="center"
                          style="height: 100px"
                        >
                          <b-col
                            v-for="player in midArr"
                            :key="player.id"
                            class="pl-0 pr-0"
                          >
                            <sup
                              v-for="event in summedArray"
                              :key="event.id"
                              style="
                                background: black;
                                padding-bottom: 5px;
                                padding-top: 3px;
                                border-radius: 50%;
                              "
                            >
                              <span v-if="event.player !== null">
                                <span
                                  v-if="player.player.id == event.player.id"
                                >
                                  <img
                                    style="width: 20px"
                                    src="@/assets/yellowcardBig.png"
                                    v-if="event.eventType == 'yellowcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/missed.png"
                                    v-else-if="
                                      event.eventType == 'missed_penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/goalBig.png"
                                    v-else-if="
                                      event.eventType == 'goal' ||
                                      event.eventType == 'penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/redCardBig.png"
                                    v-else-if="event.eventType == 'redcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/yellowred.png"
                                    v-else-if="event.eventType == 'yellowred'"
                                  /><img
                                    v-else-if="event.eventType == 'var'"
                                    style="width: 20px"
                                    src="@/assets/varCancel.png"
                                  />
                                  <img
                                    v-else-if="event.eventType == 'own-goal'"
                                    style="width: 20px"
                                    src="@/assets/ownGoal.png"
                                  />
                                  <img
                                    v-else-if="
                                      event.eventType == 'substitution'
                                    "
                                    style="width: 20px"
                                    src="@/assets/subIn.png"
                                  />
                                  <span v-else>{{
                                    event.eventType
                                      | transliterate(cookiesObject.lang)
                                  }}</span>
                                </span>
                              </span>
                            </sup>
                            <br />
                            <img
                              :src="playerLogo + player.player.id"
                              alt=""
                              class="plImage"
                              style="background: #e6e6e6; border-radius: 50%"
                            />
                            <br />
                            <span
                              style="
                                background: #1a1a1d;
                                border-radius: 5px;
                                font-size: 10px;
                                padding: 2px;
                              "
                            >
                              <span v-if="player.player.shortName">{{
                                player.player.shortName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                              <span v-else>{{
                                player.player.commonName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span></span
                            >
                          </b-col>
                        </b-row>

                        <b-row class="rCl" align-v="end" style="height: 100px">
                          <b-col
                            v-for="player in defArr"
                            :key="player.id"
                            class="pl-0 pr-0"
                          >
                            <sup
                              v-for="event in summedArray"
                              :key="event.id"
                              style="
                                background: black;
                                padding-bottom: 5px;
                                padding-top: 3px;
                                border-radius: 50%;
                              "
                            >
                              <span v-if="event.player !== null">
                                <span
                                  v-if="player.player.id == event.player.id"
                                >
                                  <img
                                    style="width: 20px"
                                    src="@/assets/yellowcardBig.png"
                                    v-if="event.eventType == 'yellowcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/missed.png"
                                    v-else-if="
                                      event.eventType == 'missed_penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/goalBig.png"
                                    v-else-if="
                                      event.eventType == 'goal' ||
                                      event.eventType == 'penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/redCardBig.png"
                                    v-else-if="event.eventType == 'redcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/yellowred.png"
                                    v-else-if="event.eventType == 'yellowred'"
                                  /><img
                                    v-else-if="event.eventType == 'var'"
                                    style="width: 20px"
                                    src="@/assets/varCancel.png"
                                  />
                                  <img
                                    v-else-if="event.eventType == 'own-goal'"
                                    style="width: 20px"
                                    src="@/assets/ownGoal.png"
                                  />
                                  <img
                                    v-else-if="
                                      event.eventType == 'substitution'
                                    "
                                    style="width: 20px"
                                    src="@/assets/subIn.png"
                                  />
                                  <span v-else>{{
                                    event.eventType
                                      | transliterate(cookiesObject.lang)
                                  }}</span>
                                </span>
                              </span>
                            </sup>
                            <br />
                            <img
                              :src="playerLogo + player.player.id"
                              alt=""
                              class="plImage"
                              style="background: #e6e6e6; border-radius: 50%"
                            />
                            <br />
                            <span
                              style="
                                background: #1a1a1d;
                                border-radius: 5px;
                                font-size: 10px;
                                padding: 2px;
                              "
                            >
                              <span v-if="player.player.shortName">{{
                                player.player.shortName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                              <span v-else>{{
                                player.player.commonName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span></span
                            >
                          </b-col>
                        </b-row>

                        <b-row
                          class="rCl"
                          align-v="center"
                          style="height: 100px"
                        >
                          <b-col style="padding-bottom: 10px">
                            <img
                              v-if="gKeeper1[0]"
                              :src="playerLogo + gKeeper1[0].player.id"
                              alt=""
                              class="plImage"
                              style="background: #e6e6e6; border-radius: 50%"
                            />
                            <br />
                            <span
                              v-if="gKeeper1[0]"
                              style="
                                background: #1a1a1d;
                                border-radius: 5px;
                                font-size: 10px;
                                padding: 2px;
                              "
                            >
                              <span v-if="gKeeper1[0].player.shortName">{{
                                gKeeper1[0].player.shortName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                              <span v-else>{{
                                gKeeper1[0].player.commonName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span></span
                            >
                          </b-col>
                        </b-row>
                      </b-container>
                    </div>

                    <!-- case 4 -->
                    <div v-else class="fF container">
                      <b-container
                        class="bv-example-row bv-example-row-flex-cols Fnames"
                        style="text-align: center"
                      >
                        <b-row class="rCl" style="height: 85px">
                          <b-col
                            v-for="player in addArr"
                            :key="player.id"
                            class="pl-0 pr-0"
                          >
                            <sup
                              v-for="event in summedArray"
                              :key="event.id"
                              style="
                                background: black;
                                padding-bottom: 5px;
                                padding-top: 3px;
                                border-radius: 50%;
                              "
                            >
                              <span v-if="event.player !== null">
                                <span
                                  v-if="player.player.id == event.player.id"
                                >
                                  <img
                                    style="width: 20px"
                                    src="@/assets/yellowcardBig.png"
                                    v-if="event.eventType == 'yellowcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/missed.png"
                                    v-else-if="
                                      event.eventType == 'missed_penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/goalBig.png"
                                    v-else-if="
                                      event.eventType == 'goal' ||
                                      event.eventType == 'penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/redCardBig.png"
                                    v-else-if="event.eventType == 'redcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/yellowred.png"
                                    v-else-if="event.eventType == 'yellowred'"
                                  /><img
                                    v-else-if="event.eventType == 'var'"
                                    style="width: 20px"
                                    src="@/assets/varCancel.png"
                                  />
                                  <img
                                    v-else-if="event.eventType == 'own-goal'"
                                    style="width: 20px"
                                    src="@/assets/ownGoal.png"
                                  />
                                  <img
                                    v-else-if="
                                      event.eventType == 'substitution'
                                    "
                                    style="width: 20px"
                                    src="@/assets/subIn.png"
                                  />
                                  <span v-else>{{
                                    event.eventType
                                      | transliterate(cookiesObject.lang)
                                  }}</span>
                                </span>
                              </span>
                            </sup>
                            <br />
                            <img
                              :src="playerLogo + player.player.id"
                              alt=""
                              class="plImage"
                              style="background: #e6e6e6; border-radius: 50%"
                            />
                            <br />
                            <span
                              style="
                                background: #1a1a1d;
                                border-radius: 5px;
                                font-size: 10px;
                                padding: 2px;
                              "
                            >
                              <span v-if="player.player.shortName">{{
                                player.player.shortName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                              <span v-else>{{
                                player.player.commonName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span></span
                            >
                          </b-col>
                        </b-row>

                        <b-row class="rCl" align-v="start" style="height: 85px">
                          <b-col
                            v-for="player in attArr"
                            :key="player.id"
                            class="pl-0 pr-0"
                          >
                            <sup
                              v-for="event in summedArray"
                              :key="event.id"
                              style="
                                background: black;
                                padding-bottom: 5px;
                                padding-top: 3px;
                                border-radius: 50%;
                              "
                            >
                              <span v-if="event.player !== null">
                                <span
                                  v-if="player.player.id == event.player.id"
                                >
                                  <img
                                    style="width: 20px"
                                    src="@/assets/yellowcardBig.png"
                                    v-if="event.eventType == 'yellowcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/missed.png"
                                    v-else-if="
                                      event.eventType == 'missed_penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/goalBig.png"
                                    v-else-if="
                                      event.eventType == 'goal' ||
                                      event.eventType == 'penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/redCardBig.png"
                                    v-else-if="event.eventType == 'redcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/yellowred.png"
                                    v-else-if="event.eventType == 'yellowred'"
                                  /><img
                                    v-else-if="event.eventType == 'var'"
                                    style="width: 20px"
                                    src="@/assets/varCancel.png"
                                  />
                                  <img
                                    v-else-if="event.eventType == 'own-goal'"
                                    style="width: 20px"
                                    src="@/assets/ownGoal.png"
                                  />
                                  <img
                                    v-else-if="
                                      event.eventType == 'substitution'
                                    "
                                    style="width: 20px"
                                    src="@/assets/subIn.png"
                                  />
                                  <span v-else>{{
                                    event.eventType
                                      | transliterate(cookiesObject.lang)
                                  }}</span>
                                </span>
                              </span>
                            </sup>
                            <br />
                            <img
                              :src="playerLogo + player.player.id"
                              alt=""
                              class="plImage"
                              style="background: #e6e6e6; border-radius: 50%"
                            />
                            <br />
                            <span
                              style="
                                background: #1a1a1d;
                                border-radius: 5px;
                                font-size: 10px;
                                padding: 2px;
                              "
                            >
                              <span v-if="player.player.shortName">{{
                                player.player.shortName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                              <span v-else>{{
                                player.player.commonName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span></span
                            >
                          </b-col>
                        </b-row>

                        <b-row
                          class="rCl"
                          align-v="center"
                          style="height: 85px"
                        >
                          <b-col
                            v-for="player in midArr"
                            :key="player.id"
                            class="pl-0 pr-0"
                          >
                            <sup
                              v-for="event in summedArray"
                              :key="event.id"
                              style="
                                background: black;
                                padding-bottom: 5px;
                                padding-top: 3px;
                                border-radius: 50%;
                              "
                            >
                              <span v-if="event.player !== null">
                                <span
                                  v-if="player.player.id == event.player.id"
                                >
                                  <img
                                    style="width: 20px"
                                    src="@/assets/yellowcardBig.png"
                                    v-if="event.eventType == 'yellowcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/missed.png"
                                    v-else-if="
                                      event.eventType == 'missed_penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/goalBig.png"
                                    v-else-if="
                                      event.eventType == 'goal' ||
                                      event.eventType == 'penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/redCardBig.png"
                                    v-else-if="event.eventType == 'redcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/yellowred.png"
                                    v-else-if="event.eventType == 'yellowred'"
                                  /><img
                                    v-else-if="event.eventType == 'var'"
                                    style="width: 20px"
                                    src="@/assets/varCancel.png"
                                  />
                                  <img
                                    v-else-if="event.eventType == 'own-goal'"
                                    style="width: 20px"
                                    src="@/assets/ownGoal.png"
                                  />
                                  <img
                                    v-else-if="
                                      event.eventType == 'substitution'
                                    "
                                    style="width: 20px"
                                    src="@/assets/subIn.png"
                                  />
                                  <span v-else>{{
                                    event.eventType
                                      | transliterate(cookiesObject.lang)
                                  }}</span>
                                </span>
                              </span>
                            </sup>
                            <br />
                            <img
                              :src="playerLogo + player.player.id"
                              class="plImage"
                              alt=""
                              style="background: #e6e6e6; border-radius: 50%"
                            />
                            <br />
                            <span
                              style="
                                background: #1a1a1d;
                                border-radius: 5px;
                                font-size: 10px;
                                padding: 2px;
                              "
                            >
                              <span v-if="player.player.shortName">{{
                                player.player.shortName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                              <span v-else>{{
                                player.player.commonName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span></span
                            >
                          </b-col>
                        </b-row>

                        <b-row class="rCl" align-v="end" style="height: 85px">
                          <b-col
                            v-for="player in defArr"
                            :key="player.id"
                            class="pl-0 pr-0"
                          >
                            <sup
                              v-for="event in summedArray"
                              :key="event.id"
                              style="
                                background: black;
                                padding-bottom: 5px;
                                padding-top: 3px;
                                border-radius: 50%;
                              "
                            >
                              <span v-if="event.player !== null">
                                <span
                                  v-if="player.player.id == event.player.id"
                                >
                                  <img
                                    style="width: 20px"
                                    src="@/assets/yellowcardBig.png"
                                    v-if="event.eventType == 'yellowcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/missed.png"
                                    v-else-if="
                                      event.eventType == 'missed_penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/goalBig.png"
                                    v-else-if="
                                      event.eventType == 'goal' ||
                                      event.eventType == 'penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/redCardBig.png"
                                    v-else-if="event.eventType == 'redcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/yellowred.png"
                                    v-else-if="event.eventType == 'yellowred'"
                                  /><img
                                    v-else-if="event.eventType == 'var'"
                                    style="width: 20px"
                                    src="@/assets/varCancel.png"
                                  />
                                  <img
                                    v-else-if="event.eventType == 'own-goal'"
                                    style="width: 20px"
                                    src="@/assets/ownGoal.png"
                                  />
                                  <img
                                    v-else-if="
                                      event.eventType == 'substitution'
                                    "
                                    style="width: 20px"
                                    src="@/assets/subIn.png"
                                  />
                                  <span v-else>{{
                                    event.eventType
                                      | transliterate(cookiesObject.lang)
                                  }}</span>
                                </span>
                              </span>
                            </sup>
                            <br />
                            <img
                              :src="playerLogo + player.player.id"
                              alt=""
                              class="plImage"
                              style="background: #e6e6e6; border-radius: 50%"
                            />
                            <br />
                            <span
                              style="
                                background: #1a1a1d;
                                border-radius: 5px;
                                font-size: 10px;
                                padding: 2px;
                              "
                            >
                              <span v-if="player.player.shortName">{{
                                player.player.shortName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                              <span v-else>{{
                                player.player.commonName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span></span
                            >
                          </b-col>
                        </b-row>

                        <b-row
                          class="rCl"
                          align-v="center"
                          style="height: 85px"
                        >
                          <b-col>
                            <img
                              v-if="gKeeper1[0]"
                              :src="playerLogo + gKeeper1[0].player.id"
                              class="plImage"
                              alt=""
                              style="background: #e6e6e6; border-radius: 50%"
                            />
                            <br />
                            <span
                              v-if="gKeeper1[0]"
                              style="
                                background: #1a1a1d;
                                border-radius: 5px;
                                font-size: 10px;
                                padding: 2px;
                              "
                            >
                              <span v-if="gKeeper1[0].player.shortName">{{
                                gKeeper1[0].player.shortName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                              <span v-else>{{
                                gKeeper1[0].player.commonName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span></span
                            >
                          </b-col>
                        </b-row>
                      </b-container>
                    </div>
                    <div
                      class=""
                      style="
                        height: 12px !important;
                        background: #141416 !important;
                      "
                    ></div>
                    <div
                      v-if="MatchStats.match.lineups[0]"
                      style="font-size: 12px"
                    >
                      <li
                        class="list-group-item infoItemHead"
                        style="background: #212225"
                      >
                        <div class="row">
                          <div class="col-9">
                            {{
                              MatchStats.match.lineups[0].team.name
                                | transliterate(cookiesObject.lang)
                            }}
                          </div>
                          <div class="col" style="text-align: center">
                            {{
                              MatchStats.match.team1Formation
                                | transliterate(cookiesObject.lang)
                            }}
                          </div>
                        </div>
                      </li>
                      <li
                        class="list-group-item infoItem"
                        v-for="lineup in mainLineup1"
                        :key="lineup.idd"
                        style="
                          border-radius: 0px;
                          border-right: none;
                          background: #141416;
                        "
                      >
                        <div class="row">
                          <div class="col">
                            <router-link
                              class="row"
                              style="color: white; text-decoration: none"
                              :to="{
                                name: 'PlayerPage',
                                params: { id: lineup.player.id },
                              }"
                            >
                              <span class="col-1">
                                {{
                                  lineup.shirtNumber
                                    | transliterate(cookiesObject.lang)
                                }}
                              </span>
                              <span
                                class="col-1 mr-1"
                                v-if="lineup.player.country"
                                ><img
                                  :src="CountLogo + lineup.player.country.id"
                                  style="width: 15px; border-radius: 2px"
                                  alt=""
                              /></span>
                              <span v-if="lineup.player.shortName">{{
                                lineup.player.shortName
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                              <span v-else>{{
                                lineup.player.commonName
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                              <span
                                v-for="event in summedArray"
                                :key="event.id"
                              >
                                <span v-if="event.player !== null">
                                  <span
                                    v-if="lineup.player.id == event.player.id"
                                  >
                                    <img
                                      style="width: 20px"
                                      src="@/assets/yellowcardBig.png"
                                      v-if="event.eventType == 'yellowcard'"
                                    /><img
                                      style="width: 20px"
                                      src="@/assets/missed.png"
                                      v-else-if="
                                        event.eventType == 'missed_penalty'
                                      "
                                    /><img
                                      style="width: 20px"
                                      src="@/assets/goalBig.png"
                                      v-else-if="
                                        event.eventType == 'goal' ||
                                        event.eventType == 'penalty'
                                      "
                                    /><img
                                      style="width: 20px"
                                      src="@/assets/redCardBig.png"
                                      v-else-if="event.eventType == 'redcard'"
                                    /><img
                                      style="width: 20px"
                                      src="@/assets/yellowred.png"
                                      v-else-if="event.eventType == 'yellowred'"
                                    /><img
                                      v-else-if="event.eventType == 'var'"
                                      style="width: 20px"
                                      src="@/assets/varCancel.png"
                                    />
                                    <img
                                      v-else-if="event.eventType == 'own-goal'"
                                      style="width: 20px"
                                      src="@/assets/ownGoal.png"
                                    />
                                    <img
                                      v-else-if="
                                        event.eventType == 'substitution'
                                      "
                                      style="width: 20px"
                                      src="@/assets/subIn.png"
                                    />
                                    <span v-else>{{
                                      event.eventType
                                        | transliterate(cookiesObject.lang)
                                    }}</span>
                                  </span>
                                </span>
                                <span
                                  style="color: grey; font-size: 11px"
                                  v-if="
                                    event.assistant !== null &&
                                    event.player !== null &&
                                    event.eventType == 'substitution' &&
                                    lineup.player.id == event.assistant.id
                                  "
                                  ><img
                                    style="width: 15px"
                                    src="@/assets/subIn.png"
                                  />
                                  <span v-if="event.player.shortName">{{
                                    event.player.shortName
                                      | transliterate(cookiesObject.lang)
                                  }}</span>
                                  <span v-else>{{
                                    event.player.commonName
                                      | transliterate(cookiesObject.lang)
                                  }}</span></span
                                >
                              </span>
                            </router-link>
                          </div>
                        </div>
                      </li>
                    </div>
                    <div v-else>
                      <li
                        class="list-group-item listHeader"
                        style="border-radius: 0px"
                      >
                        <img
                          style="margin-bottom: 3px"
                          src="@/assets/noInfo.svg"
                        />{{ $t("LanguageEn.noInfo") }}
                      </li>
                    </div>
                    <div
                      class=""
                      style="
                        height: 12px !important;
                        background: #141416 !important;
                      "
                    ></div>
                    <div
                      v-if="MatchStats.match.lineups[0]"
                      style="font-size: 12px"
                    >
                      <li
                        class="list-group-item infoItemHead"
                        style="background: #212225"
                      >
                        <div class="row">
                          <div class="col-9">
                            {{ $t("LanguageEn.subst") }}
                          </div>
                        </div>
                      </li>
                      <li
                        class="list-group-item infoItem"
                        v-for="lineup in subLineup1"
                        :key="lineup.idd"
                        style="
                          border-radius: 0px;
                          border-right: none;
                          background: #141416;
                        "
                      >
                        <div class="row">
                          <div class="col">
                            <router-link
                              class="row"
                              style="color: white; text-decoration: none"
                              :to="{
                                name: 'PlayerPage',
                                params: { id: lineup.player.id },
                              }"
                            >
                              <span class="col-1">
                                {{
                                  lineup.shirtNumber
                                    | transliterate(cookiesObject.lang)
                                }}
                              </span>
                              <span
                                class="col-1 mr-1"
                                v-if="lineup.player.country"
                                ><img
                                  :src="CountLogo + lineup.player.country.id"
                                  style="width: 15px; border-radius: 2px"
                                  alt=""
                              /></span>
                              <span v-if="lineup.player.shortName">{{
                                lineup.player.shortName
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                              <span v-else>{{
                                lineup.player.commonName
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                              <span
                                v-for="event in summedArray"
                                :key="event.id"
                              >
                                <span v-if="event.player !== null">
                                  <span
                                    v-if="lineup.player.id == event.player.id"
                                  >
                                    <img
                                      style="width: 20px"
                                      src="@/assets/yellowcardBig.png"
                                      v-if="event.eventType == 'yellowcard'"
                                    /><img
                                      style="width: 20px"
                                      src="@/assets/missed.png"
                                      v-else-if="
                                        event.eventType == 'missed_penalty'
                                      "
                                    /><img
                                      style="width: 20px"
                                      src="@/assets/goalBig.png"
                                      v-else-if="
                                        event.eventType == 'goal' ||
                                        event.eventType == 'penalty'
                                      "
                                    /><img
                                      style="width: 20px"
                                      src="@/assets/redCardBig.png"
                                      v-else-if="event.eventType == 'redcard'"
                                    /><img
                                      style="width: 20px"
                                      src="@/assets/yellowred.png"
                                      v-else-if="event.eventType == 'yellowred'"
                                    /><img
                                      v-else-if="event.eventType == 'var'"
                                      style="width: 20px"
                                      src="@/assets/varCancel.png"
                                    />
                                    <img
                                      v-else-if="event.eventType == 'own-goal'"
                                      style="width: 20px"
                                      src="@/assets/ownGoal.png"
                                    />
                                    <img
                                      v-else-if="
                                        event.eventType == 'substitution'
                                      "
                                      style="width: 20px"
                                      src="@/assets/subIn.png"
                                    />
                                    <span v-else>{{
                                      event.eventType
                                        | transliterate(cookiesObject.lang)
                                    }}</span>
                                  </span>
                                </span>
                                <span
                                  style="color: grey; font-size: 11px"
                                  v-if="
                                    event.assistant !== null &&
                                    event.player !== null &&
                                    event.eventType == 'substitution' &&
                                    lineup.player.id == event.assistant.id
                                  "
                                  ><img
                                    style="width: 15px"
                                    src="@/assets/subIn.png"
                                  />
                                  <span v-if="event.player.shortName">{{
                                    event.player.shortName
                                      | transliterate(cookiesObject.lang)
                                  }}</span>
                                  <span v-else>{{
                                    event.player.commonName
                                      | transliterate(cookiesObject.lang)
                                  }}</span></span
                                >
                              </span>
                            </router-link>
                          </div>
                        </div>
                      </li>
                    </div>
                    <div v-else>
                      <li
                        class="list-group-item listHeader"
                        style="border-radius: 0px"
                      >
                        <img
                          style="margin-bottom: 3px"
                          src="@/assets/noInfo.svg"
                        />{{ $t("LanguageEn.noInfo") }}
                      </li>
                    </div>
                  </b-tab>
                  <b-tab>
                    <!-- team2 tab -->
                    <template v-slot:title>
                      <p
                        style="
                          margin: 0px;
                          font-weight: 550;
                          color: #e6e6e6;
                          font-size: 11px;
                        "
                      >
                        {{ team2name | transliterate(cookiesObject.lang) }}
                      </p>
                    </template>
                    <div v-if="team2F == 3" class="fF container">
                      <b-container
                        class="bv-example-row bv-example-row-flex-cols Fnames"
                        style="text-align: center; padding-top: 20px"
                      >
                        <b-row
                          class="rCl"
                          align-v="start"
                          style="height: 100px"
                        >
                          <b-col
                            v-for="player in attArr2"
                            :key="player.id"
                            class="pl-0 pr-0"
                          >
                            <sup
                              v-for="event in summedArray"
                              :key="event.id"
                              style="
                                background: black;
                                padding-bottom: 5px;
                                padding-top: 3px;
                                border-radius: 50%;
                              "
                            >
                              <span v-if="event.player !== null">
                                <span
                                  v-if="player.player.id == event.player.id"
                                >
                                  <img
                                    style="width: 20px"
                                    src="@/assets/yellowcardBig.png"
                                    v-if="event.eventType == 'yellowcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/missed.png"
                                    v-else-if="
                                      event.eventType == 'missed_penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/goalBig.png"
                                    v-else-if="
                                      event.eventType == 'goal' ||
                                      event.eventType == 'penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/redCardBig.png"
                                    v-else-if="event.eventType == 'redcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/yellowred.png"
                                    v-else-if="event.eventType == 'yellowred'"
                                  /><img
                                    v-else-if="event.eventType == 'var'"
                                    style="width: 20px"
                                    src="@/assets/varCancel.png"
                                  />
                                  <img
                                    v-else-if="event.eventType == 'own-goal'"
                                    style="width: 20px"
                                    src="@/assets/ownGoal.png"
                                  />
                                  <img
                                    v-else-if="
                                      event.eventType == 'substitution'
                                    "
                                    style="width: 20px"
                                    src="@/assets/subIn.png"
                                  />
                                  <span v-else>{{
                                    event.eventType
                                      | transliterate(cookiesObject.lang)
                                  }}</span>
                                </span>
                              </span>
                            </sup>
                            <br />
                            <img
                              :src="playerLogo + player.player.id"
                              class="plImage"
                              alt=""
                              style="background: #e6e6e6; border-radius: 50%"
                            />
                            <br />
                            <span
                              style="
                                background: #1a1a1d;
                                border-radius: 5px;
                                font-size: 10px;
                                padding: 2px;
                              "
                            >
                              <span v-if="player.player.shortName">{{
                                player.player.shortName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                              <span v-else>{{
                                player.player.commonName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span></span
                            >
                          </b-col>
                        </b-row>

                        <b-row
                          class="rCl"
                          align-v="center"
                          style="height: 100px"
                        >
                          <b-col
                            v-for="player in midArr2"
                            :key="player.id"
                            class="pl-0 pr-0"
                          >
                            <sup
                              v-for="event in summedArray"
                              :key="event.id"
                              style="
                                background: black;
                                padding-bottom: 5px;
                                padding-top: 3px;
                                border-radius: 50%;
                              "
                            >
                              <span v-if="event.player !== null">
                                <span
                                  v-if="player.player.id == event.player.id"
                                >
                                  <img
                                    style="width: 20px"
                                    src="@/assets/yellowcardBig.png"
                                    v-if="event.eventType == 'yellowcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/missed.png"
                                    v-else-if="
                                      event.eventType == 'missed_penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/goalBig.png"
                                    v-else-if="
                                      event.eventType == 'goal' ||
                                      event.eventType == 'penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/redCardBig.png"
                                    v-else-if="event.eventType == 'redcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/yellowred.png"
                                    v-else-if="event.eventType == 'yellowred'"
                                  /><img
                                    v-else-if="event.eventType == 'var'"
                                    style="width: 20px"
                                    src="@/assets/varCancel.png"
                                  />
                                  <img
                                    v-else-if="event.eventType == 'own-goal'"
                                    style="width: 20px"
                                    src="@/assets/ownGoal.png"
                                  />
                                  <img
                                    v-else-if="
                                      event.eventType == 'substitution'
                                    "
                                    style="width: 20px"
                                    src="@/assets/subIn.png"
                                  />
                                  <span v-else>{{
                                    event.eventType
                                      | transliterate(cookiesObject.lang)
                                  }}</span>
                                </span>
                              </span>
                            </sup>
                            <br />
                            <img
                              :src="playerLogo + player.player.id"
                              class="plImage"
                              alt=""
                              style="background: #e6e6e6; border-radius: 50%"
                            />
                            <br />
                            <span
                              style="
                                background: #1a1a1d;
                                border-radius: 5px;
                                font-size: 10px;
                                padding: 2px;
                              "
                            >
                              <span v-if="player.player.shortName">{{
                                player.player.shortName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                              <span v-else>{{
                                player.player.commonName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span></span
                            >
                          </b-col>
                        </b-row>

                        <b-row class="rCl" align-v="end" style="height: 100px">
                          <b-col
                            v-for="player in defArr2"
                            :key="player.id"
                            class="pl-0 pr-0"
                          >
                            <sup
                              v-for="event in summedArray"
                              :key="event.id"
                              style="
                                background: black;
                                padding-bottom: 5px;
                                padding-top: 3px;
                                border-radius: 50%;
                              "
                            >
                              <span v-if="event.player !== null">
                                <span
                                  v-if="player.player.id == event.player.id"
                                >
                                  <img
                                    style="width: 20px"
                                    src="@/assets/yellowcardBig.png"
                                    v-if="event.eventType == 'yellowcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/missed.png"
                                    v-else-if="
                                      event.eventType == 'missed_penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/goalBig.png"
                                    v-else-if="
                                      event.eventType == 'goal' ||
                                      event.eventType == 'penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/redCardBig.png"
                                    v-else-if="event.eventType == 'redcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/yellowred.png"
                                    v-else-if="event.eventType == 'yellowred'"
                                  /><img
                                    v-else-if="event.eventType == 'var'"
                                    style="width: 20px"
                                    src="@/assets/varCancel.png"
                                  />
                                  <img
                                    v-else-if="event.eventType == 'own-goal'"
                                    style="width: 20px"
                                    src="@/assets/ownGoal.png"
                                  />
                                  <img
                                    v-else-if="
                                      event.eventType == 'substitution'
                                    "
                                    style="width: 20px"
                                    src="@/assets/subIn.png"
                                  />
                                  <span v-else>{{
                                    event.eventType
                                      | transliterate(cookiesObject.lang)
                                  }}</span>
                                </span>
                              </span>
                            </sup>
                            <br />
                            <img
                              :src="playerLogo + player.player.id"
                              alt=""
                              class="plImage"
                              style="background: #e6e6e6; border-radius: 50%"
                            />
                            <br />
                            <span
                              style="
                                background: #1a1a1d;
                                border-radius: 5px;
                                font-size: 10px;
                                padding: 2px;
                              "
                            >
                              <span v-if="player.player.shortName">{{
                                player.player.shortName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                              <span v-else>{{
                                player.player.commonName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span></span
                            >
                          </b-col>
                        </b-row>

                        <b-row
                          class="rCl"
                          align-v="center"
                          style="height: 100px"
                        >
                          <b-col class="pl-0 pr-0">
                            <img
                              :src="playerLogo + gKeeper2[0].player.id"
                              alt=""
                              class="plImage"
                              style="background: #e6e6e6; border-radius: 50%"
                            />
                            <br />
                            <span
                              style="
                                background: #1a1a1d;
                                border-radius: 5px;
                                font-size: 10px;
                                padding: 2px;
                              "
                            >
                              <span v-if="gKeeper2[0].player.shortName">{{
                                gKeeper2[0].player.shortName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                              <span v-else>{{
                                gKeeper2[0].player.commonName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span></span
                            >
                          </b-col>
                        </b-row>
                      </b-container>
                    </div>

                    <!-- case 4 -->
                    <div v-else class="fF container">
                      <b-container
                        class="bv-example-row bv-example-row-flex-cols Fnames"
                        style="text-align: center; padding-top: 20px"
                      >
                        <b-row class="rCl" style="height: 85px">
                          <b-col
                            v-for="player in addArr2"
                            :key="player.id"
                            class="pl-0 pr-0"
                          >
                            <sup
                              v-for="event in summedArray"
                              :key="event.id"
                              style="
                                background: black;
                                padding-bottom: 5px;
                                padding-top: 3px;
                                border-radius: 50%;
                              "
                            >
                              <span v-if="event.player !== null">
                                <span
                                  v-if="player.player.id == event.player.id"
                                >
                                  <img
                                    style="width: 20px"
                                    src="@/assets/yellowcardBig.png"
                                    v-if="event.eventType == 'yellowcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/missed.png"
                                    v-else-if="
                                      event.eventType == 'missed_penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/goalBig.png"
                                    v-else-if="
                                      event.eventType == 'goal' ||
                                      event.eventType == 'penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/redCardBig.png"
                                    v-else-if="event.eventType == 'redcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/yellowred.png"
                                    v-else-if="event.eventType == 'yellowred'"
                                  /><img
                                    v-else-if="event.eventType == 'var'"
                                    style="width: 20px"
                                    src="@/assets/varCancel.png"
                                  />
                                  <img
                                    v-else-if="event.eventType == 'own-goal'"
                                    style="width: 20px"
                                    src="@/assets/ownGoal.png"
                                  />
                                  <img
                                    v-else-if="
                                      event.eventType == 'substitution'
                                    "
                                    style="width: 20px"
                                    src="@/assets/subIn.png"
                                  />
                                  <span v-else>{{
                                    event.eventType
                                      | transliterate(cookiesObject.lang)
                                  }}</span>
                                </span>
                              </span>
                            </sup>
                            <br />
                            <img
                              :src="playerLogo + player.player.id"
                              class="plImage"
                              alt=""
                              style="background: #e6e6e6; border-radius: 50%"
                            />
                            <br />
                            <span
                              style="
                                background: #1a1a1d;
                                border-radius: 5px;
                                font-size: 10px;
                                padding: 2px;
                              "
                            >
                              <span v-if="player.player.shortName">{{
                                player.player.shortName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                              <span v-else>{{
                                player.player.commonName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span></span
                            >
                          </b-col>
                        </b-row>

                        <b-row class="rCl" align-v="start" style="height: 85px">
                          <b-col
                            v-for="player in attArr2"
                            :key="player.id"
                            class="pl-0 pr-0"
                          >
                            <sup
                              v-for="event in summedArray"
                              :key="event.id"
                              style="
                                background: black;
                                padding-bottom: 5px;
                                padding-top: 3px;
                                border-radius: 50%;
                              "
                            >
                              <span v-if="event.player !== null">
                                <span
                                  v-if="player.player.id == event.player.id"
                                >
                                  <img
                                    style="width: 20px"
                                    src="@/assets/yellowcardBig.png"
                                    v-if="event.eventType == 'yellowcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/missed.png"
                                    v-else-if="
                                      event.eventType == 'missed_penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/goalBig.png"
                                    v-else-if="
                                      event.eventType == 'goal' ||
                                      event.eventType == 'penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/redCardBig.png"
                                    v-else-if="event.eventType == 'redcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/yellowred.png"
                                    v-else-if="event.eventType == 'yellowred'"
                                  /><img
                                    v-else-if="event.eventType == 'var'"
                                    style="width: 20px"
                                    src="@/assets/varCancel.png"
                                  />
                                  <img
                                    v-else-if="event.eventType == 'own-goal'"
                                    style="width: 20px"
                                    src="@/assets/ownGoal.png"
                                  />
                                  <img
                                    v-else-if="
                                      event.eventType == 'substitution'
                                    "
                                    style="width: 20px"
                                    src="@/assets/subIn.png"
                                  />
                                  <span v-else>{{
                                    event.eventType
                                      | transliterate(cookiesObject.lang)
                                  }}</span>
                                </span>
                              </span>
                            </sup>
                            <br />
                            <img
                              :src="playerLogo + player.player.id"
                              alt=""
                              class="plImage"
                              style="background: #e6e6e6; border-radius: 50%"
                            />
                            <br />
                            <span
                              style="
                                background: #1a1a1d;
                                border-radius: 5px;
                                font-size: 10px;
                                padding: 2px;
                              "
                            >
                              <span v-if="player.player.shortName">{{
                                player.player.shortName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                              <span v-else>{{
                                player.player.commonName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span></span
                            >
                          </b-col>
                        </b-row>

                        <b-row
                          class="rCl"
                          align-v="center"
                          style="height: 85px"
                        >
                          <b-col
                            v-for="player in midArr2"
                            :key="player.id"
                            class="pl-0 pr-0"
                          >
                            <sup
                              v-for="event in summedArray"
                              :key="event.id"
                              style="
                                background: black;
                                padding-bottom: 5px;
                                padding-top: 3px;
                                border-radius: 50%;
                              "
                            >
                              <span v-if="event.player !== null">
                                <span
                                  v-if="player.player.id == event.player.id"
                                >
                                  <img
                                    style="width: 20px"
                                    src="@/assets/yellowcardBig.png"
                                    v-if="event.eventType == 'yellowcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/missed.png"
                                    v-else-if="
                                      event.eventType == 'missed_penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/goalBig.png"
                                    v-else-if="
                                      event.eventType == 'goal' ||
                                      event.eventType == 'penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/redCardBig.png"
                                    v-else-if="event.eventType == 'redcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/yellowred.png"
                                    v-else-if="event.eventType == 'yellowred'"
                                  /><img
                                    v-else-if="event.eventType == 'var'"
                                    style="width: 20px"
                                    src="@/assets/varCancel.png"
                                  />
                                  <img
                                    v-else-if="event.eventType == 'own-goal'"
                                    style="width: 20px"
                                    src="@/assets/ownGoal.png"
                                  />
                                  <img
                                    v-else-if="
                                      event.eventType == 'substitution'
                                    "
                                    style="width: 20px"
                                    src="@/assets/subIn.png"
                                  />
                                  <span v-else>{{
                                    event.eventType
                                      | transliterate(cookiesObject.lang)
                                  }}</span>
                                </span>
                              </span>
                            </sup>
                            <br />
                            <img
                              :src="playerLogo + player.player.id"
                              class="plImage"
                              alt=""
                              style="background: #e6e6e6; border-radius: 50%"
                            />
                            <br />
                            <span
                              style="
                                background: #1a1a1d;
                                border-radius: 5px;
                                font-size: 10px;
                                padding: 2px;
                              "
                            >
                              <span v-if="player.player.shortName">{{
                                player.player.shortName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                              <span v-else>{{
                                player.player.commonName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span></span
                            >
                          </b-col>
                        </b-row>

                        <b-row class="rCl" align-v="end" style="height: 85px">
                          <b-col
                            v-for="player in defArr2"
                            :key="player.id"
                            class="pl-0 pr-0"
                          >
                            <sup
                              v-for="event in summedArray"
                              :key="event.id"
                              style="
                                background: black;
                                padding-bottom: 5px;
                                padding-top: 3px;
                                border-radius: 50%;
                              "
                            >
                              <span v-if="event.player !== null">
                                <span
                                  v-if="player.player.id == event.player.id"
                                >
                                  <img
                                    style="width: 20px"
                                    src="@/assets/yellowcardBig.png"
                                    v-if="event.eventType == 'yellowcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/missed.png"
                                    v-else-if="
                                      event.eventType == 'missed_penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/goalBig.png"
                                    v-else-if="
                                      event.eventType == 'goal' ||
                                      event.eventType == 'penalty'
                                    "
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/redCardBig.png"
                                    v-else-if="event.eventType == 'redcard'"
                                  /><img
                                    style="width: 20px"
                                    src="@/assets/yellowred.png"
                                    v-else-if="event.eventType == 'yellowred'"
                                  /><img
                                    v-else-if="event.eventType == 'var'"
                                    style="width: 20px"
                                    src="@/assets/varCancel.png"
                                  />
                                  <img
                                    v-else-if="event.eventType == 'own-goal'"
                                    style="width: 20px"
                                    src="@/assets/ownGoal.png"
                                  />
                                  <img
                                    v-else-if="
                                      event.eventType == 'substitution'
                                    "
                                    style="width: 20px"
                                    src="@/assets/subIn.png"
                                  />
                                  <span v-else>{{
                                    event.eventType
                                      | transliterate(cookiesObject.lang)
                                  }}</span>
                                </span>
                              </span>
                            </sup>
                            <br />
                            <img
                              :src="playerLogo + player.player.id"
                              alt=""
                              class="plImage"
                              style="background: #e6e6e6; border-radius: 50%"
                            />
                            <br />
                            <span
                              style="
                                background: #1a1a1d;
                                border-radius: 5px;
                                font-size: 10px;
                                padding: 2px;
                              "
                            >
                              <span v-if="player.player.shortName">{{
                                player.player.shortName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                              <span v-else>{{
                                player.player.commonName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span></span
                            >
                          </b-col>
                        </b-row>

                        <b-row
                          class="rCl"
                          align-v="center"
                          style="height: 85px"
                        >
                          <b-col class="pl-0 pr-0">
                            <img
                              :src="playerLogo + gKeeper2[0].player.id"
                              class="plImage"
                              alt=""
                              style="background: #e6e6e6; border-radius: 50%"
                            />
                            <br />
                            <span
                              style="
                                background: #1a1a1d;
                                border-radius: 5px;
                                font-size: 10px;
                                padding: 2px;
                              "
                              ><span v-if="gKeeper2[0].player.shortName">{{
                                gKeeper2[0].player.shortName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                              <span v-else>{{
                                gKeeper2[0].player.commonName.slice(0, 18)
                                  | transliterate(cookiesObject.lang)
                              }}</span></span
                            >
                          </b-col>
                        </b-row>
                      </b-container>
                    </div>
                    <div
                      class=""
                      style="
                        height: 12px !important;
                        background: #141416 !important;
                      "
                    ></div>
                    <div
                      v-if="MatchStats.match.lineups[1]"
                      style="font-size: 12px"
                    >
                      <li
                        class="list-group-item infoItemHead"
                        style="background: #212225"
                      >
                        <div class="row">
                          <div class="col-9">
                            {{
                              MatchStats.match.lineups[1].team.name
                                | transliterate(cookiesObject.lang)
                            }}
                          </div>
                          <div class="col" style="text-align: center">
                            {{
                              MatchStats.match.team2Formation
                                | transliterate(cookiesObject.lang)
                            }}
                          </div>
                        </div>
                      </li>
                      <li
                        class="list-group-item infoItem"
                        v-for="lineup in mainLineup2"
                        :key="lineup.idk"
                        style="
                          border-radius: 0px;
                          border-left: none;
                          background: #141416;
                        "
                      >
                        <div class="row">
                          <div class="col">
                            <router-link
                              class="row"
                              style="color: white; text-decoration: none"
                              :to="{
                                name: 'PlayerPage',
                                params: { id: lineup.player.id },
                              }"
                            >
                              <span class="col-1">
                                {{
                                  lineup.shirtNumber
                                    | transliterate(cookiesObject.lang)
                                }}
                              </span>
                              <span
                                class="col-1 mr-1"
                                v-if="lineup.player.country"
                                ><img
                                  :src="CountLogo + lineup.player.country.id"
                                  style="width: 15px; border-radius: 2px"
                                  alt=""
                              /></span>
                              <span v-if="lineup.player.shortName">{{
                                lineup.player.shortName
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                              <span v-else>{{
                                lineup.player.commonName
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                              <span
                                v-for="event in summedArray"
                                :key="event.id"
                              >
                                <span v-if="event.player !== null">
                                  <span
                                    v-if="lineup.player.id == event.player.id"
                                  >
                                    <img
                                      style="width: 20px"
                                      src="@/assets/yellowcardBig.png"
                                      v-if="event.eventType == 'yellowcard'"
                                    /><img
                                      style="width: 20px"
                                      src="@/assets/missed.png"
                                      v-else-if="
                                        event.eventType == 'missed_penalty'
                                      "
                                    /><img
                                      style="width: 20px"
                                      src="@/assets/goalBig.png"
                                      v-else-if="
                                        event.eventType == 'goal' ||
                                        event.eventType == 'penalty'
                                      "
                                    /><img
                                      style="width: 20px"
                                      src="@/assets/redCardBig.png"
                                      v-else-if="event.eventType == 'redcard'"
                                    /><img
                                      style="width: 20px"
                                      src="@/assets/yellowred.png"
                                      v-else-if="event.eventType == 'yellowred'"
                                    /><img
                                      v-else-if="event.eventType == 'var'"
                                      style="width: 20px"
                                      src="@/assets/varCancel.png"
                                    />
                                    <img
                                      v-else-if="event.eventType == 'own-goal'"
                                      style="width: 20px"
                                      src="@/assets/ownGoal.png"
                                    />
                                    <img
                                      v-else-if="
                                        event.eventType == 'substitution'
                                      "
                                      style="width: 20px"
                                      src="@/assets/subIn.png"
                                    />
                                    <span v-else>{{
                                      event.eventType
                                        | transliterate(cookiesObject.lang)
                                    }}</span>
                                  </span>
                                </span>
                                <span
                                  style="color: grey; font-size: 11px"
                                  v-if="
                                    event.assistant !== null &&
                                    event.player !== null &&
                                    event.eventType == 'substitution' &&
                                    lineup.player.id == event.assistant.id
                                  "
                                  ><img
                                    style="width: 15px"
                                    src="@/assets/subIn.png"
                                  />
                                  <span v-if="event.player.shortName">{{
                                    event.player.shortName
                                      | transliterate(cookiesObject.lang)
                                  }}</span>
                                  <span v-else>{{
                                    event.player.commonName
                                      | transliterate(cookiesObject.lang)
                                  }}</span></span
                                >
                              </span>
                            </router-link>
                          </div>
                        </div>
                      </li>
                    </div>
                    <div v-else>
                      <li
                        class="list-group-item listHeader"
                        style="border-radius: 0px"
                      >
                        <img
                          style="margin-bottom: 3px"
                          src="@/assets/noInfo.svg"
                        />{{ $t("LanguageEn.noInfo") }}
                      </li>
                    </div>
                    <div
                      class=""
                      style="
                        height: 12px !important;
                        background: #141416 !important;
                      "
                    ></div>
                    <div
                      v-if="MatchStats.match.lineups[0]"
                      style="font-size: 12px"
                    >
                      <li
                        class="list-group-item infoItemHead"
                        style="background: #212225"
                      >
                        <div class="row">
                          <div class="col-9">
                            {{ $t("LanguageEn.subst") }}
                          </div>
                        </div>
                      </li>
                      <li
                        class="list-group-item infoItem"
                        v-for="lineup in subLineup2"
                        :key="lineup.idd"
                        style="
                          border-radius: 0px;
                          border-right: none;
                          background: #141416;
                        "
                      >
                        <div class="row">
                          <div class="col">
                            <router-link
                              class="row"
                              style="color: white; text-decoration: none"
                              :to="{
                                name: 'PlayerPage',
                                params: { id: lineup.player.id },
                              }"
                            >
                              <span class="col-1">
                                {{
                                  lineup.shirtNumber
                                    | transliterate(cookiesObject.lang)
                                }}
                              </span>
                              <span
                                class="col-1 mr-1"
                                v-if="lineup.player.country"
                                ><img
                                  :src="CountLogo + lineup.player.country.id"
                                  style="width: 15px; border-radius: 2px"
                                  alt=""
                              /></span>
                              <span v-if="lineup.player.shortName">{{
                                lineup.player.shortName
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                              <span v-else>{{
                                lineup.player.commonName
                                  | transliterate(cookiesObject.lang)
                              }}</span>
                              <span
                                v-for="event in summedArray"
                                :key="event.id"
                              >
                                <span v-if="event.player !== null">
                                  <span
                                    v-if="lineup.player.id == event.player.id"
                                  >
                                    <img
                                      style="width: 20px"
                                      src="@/assets/yellowcardBig.png"
                                      v-if="event.eventType == 'yellowcard'"
                                    /><img
                                      style="width: 20px"
                                      src="@/assets/missed.png"
                                      v-else-if="
                                        event.eventType == 'missed_penalty'
                                      "
                                    /><img
                                      style="width: 20px"
                                      src="@/assets/goalBig.png"
                                      v-else-if="
                                        event.eventType == 'goal' ||
                                        event.eventType == 'penalty'
                                      "
                                    /><img
                                      style="width: 20px"
                                      src="@/assets/redCardBig.png"
                                      v-else-if="event.eventType == 'redcard'"
                                    /><img
                                      style="width: 20px"
                                      src="@/assets/yellowred.png"
                                      v-else-if="event.eventType == 'yellowred'"
                                    /><img
                                      v-else-if="event.eventType == 'var'"
                                      style="width: 20px"
                                      src="@/assets/varCancel.png"
                                    />
                                    <img
                                      v-else-if="event.eventType == 'own-goal'"
                                      style="width: 20px"
                                      src="@/assets/ownGoal.png"
                                    />
                                    <img
                                      v-else-if="
                                        event.eventType == 'substitution'
                                      "
                                      style="width: 20px"
                                      src="@/assets/subIn.png"
                                    />
                                    <span v-else>{{
                                      event.eventType
                                        | transliterate(cookiesObject.lang)
                                    }}</span>
                                  </span>
                                </span>
                                <span
                                  style="color: grey; font-size: 11px"
                                  v-if="
                                    event.assistant !== null &&
                                    event.player !== null &&
                                    event.eventType == 'substitution' &&
                                    lineup.player.id == event.assistant.id
                                  "
                                  ><img
                                    style="width: 15px"
                                    src="@/assets/subIn.png"
                                  />
                                  <span v-if="event.player.shortName">{{
                                    event.player.shortName
                                      | transliterate(cookiesObject.lang)
                                  }}</span>
                                  <span v-else>{{
                                    event.player.commonName
                                      | transliterate(cookiesObject.lang)
                                  }}</span></span
                                >
                              </span>
                            </router-link>
                          </div>
                        </div>
                      </li>
                    </div>
                    <div v-else>
                      <li
                        class="list-group-item listHeader"
                        style="border-radius: 0px"
                      >
                        <img
                          style="margin-bottom: 3px"
                          src="@/assets/noInfo.svg"
                        />{{ $t("LanguageEn.noInfo") }}
                      </li>
                    </div>
                  </b-tab>
                </b-tabs>
              </div>
              <!-- or Lineups -->

              <div>
                <div
                  class=""
                  style="
                    height: 12px !important;
                    background: #141416 !important;
                  "
                ></div>

                <!-- mobile -->
                <ul class="list-group Info" style="font-size: 13px">
                  <div v-if="MatchStats.match.lineups[0]"></div>
                </ul>
              </div>
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <p
                  style="
                    margin: 0px;
                    font-weight: 550;
                    color: #e6e6e6;
                    font-size: 11px;
                  "
                >
                  {{ $t("LanguageEn.txtStatistics") }}
                </p>
              </template>
              <div
                class=""
                style="height: 12px !important; background: #141416 !important"
              ></div>
              <li
                class="list-group-item MobileHide"
                v-if="MatchStats.match.statistics.length !== 0"
                style="
                  line-height: 5px;
                  text-align: left;
                  font-size: 14px;
                  color: lightgrey;
                  font-weight: 550;
                  background: #212225;
                "
              >
                {{ $t("LanguageEn.fMatch") }}
              </li>
              <li
                class="list-group-item"
                style="
                  border-radius: 0px;
                  background: #1a1a1d;
                  font-size: 13px;
                  text-align: center;
                "
                v-if="MatchStats.match.statistics.length == 0"
              >
                <img
                  style="margin-bottom: 3px"
                  src="@/assets/noInfo.svg"
                  v-if="MatchStats.match.matchStatus.name == 'NS'"
                /><img
                  style="margin-bottom: 3px"
                  src="@/assets/noLine.svg"
                  v-else
                />
                {{ $t("LanguageEn.noInfo") }}
              </li>
              <div
                v-for="stat in MatchStats.match.statistics"
                :key="stat.id"
                v-else
              >
                <li
                  class="list-group-item"
                  style="
                    border-radius: 0px;
                    border: none;
                    text-align: center;
                    height: 10px;
                    font-size: 12px;
                    line-height: 1;
                    background: #141416;
                  "
                >
                  <p style="height: 0px" v-if="stat.statisticKey == 'attacks'">
                    <span style="float: left">{{
                      stat.team1Value | transliterate(cookiesObject.lang)
                    }}</span>
                    {{ $t("LanguageEn.statisticAttacks") }}
                    <span style="float: right">{{
                      stat.team2Value | transliterate(cookiesObject.lang)
                    }}</span>
                  </p>
                  <p
                    style="height: 0px"
                    v-else-if="stat.statisticKey == 'ball_safe'"
                  >
                    <span style="float: left">{{
                      stat.team1Value | transliterate(cookiesObject.lang)
                    }}</span>
                    {{ $t("LanguageEn.statisticBallSafe") }}
                    <span style="float: right">{{
                      stat.team2Value | transliterate(cookiesObject.lang)
                    }}</span>
                  </p>
                  <p
                    style="height: 0px"
                    v-else-if="stat.statisticKey == 'corners'"
                  >
                    <span style="float: left">{{
                      stat.team1Value | transliterate(cookiesObject.lang)
                    }}</span>
                    {{ $t("LanguageEn.statisticCorners") }}
                    <span style="float: right">{{
                      stat.team2Value | transliterate(cookiesObject.lang)
                    }}</span>
                  </p>
                  <p
                    style="height: 0px"
                    v-else-if="stat.statisticKey == 'dangerous_attacks'"
                  >
                    <span style="float: left">{{
                      stat.team1Value | transliterate(cookiesObject.lang)
                    }}</span>
                    {{ $t("LanguageEn.statisticDangerousAttacks") }}
                    <span style="float: right">{{
                      stat.team2Value | transliterate(cookiesObject.lang)
                    }}</span>
                  </p>
                  <p
                    style="height: 0px"
                    v-else-if="stat.statisticKey == 'fouls'"
                  >
                    <span style="float: left">{{
                      stat.team1Value | transliterate(cookiesObject.lang)
                    }}</span>
                    {{ $t("LanguageEn.statisticFouls") }}
                    <span style="float: right">{{
                      stat.team2Value | transliterate(cookiesObject.lang)
                    }}</span>
                  </p>
                  <p
                    style="height: 0px"
                    v-else-if="stat.statisticKey == 'goals'"
                  >
                    <span style="float: left">{{
                      stat.team1Value | transliterate(cookiesObject.lang)
                    }}</span>
                    {{ $t("LanguageEn.statisticGoals") }}
                    <span style="float: right">{{
                      stat.team2Value | transliterate(cookiesObject.lang)
                    }}</span>
                  </p>
                  <p
                    style="height: 0px"
                    v-else-if="stat.statisticKey == 'goal_attempts'"
                  >
                    <span style="float: left">{{
                      stat.team1Value | transliterate(cookiesObject.lang)
                    }}</span>
                    {{ $t("LanguageEn.statisticGoalAttempts") }}
                    <span style="float: right">{{
                      stat.team2Value | transliterate(cookiesObject.lang)
                    }}</span>
                  </p>
                  <p
                    style="height: 0px"
                    v-else-if="stat.statisticKey == 'injuries'"
                  >
                    <span style="float: left">{{
                      stat.team1Value | transliterate(cookiesObject.lang)
                    }}</span>
                    {{ $t("LanguageEn.statisticInjuries") }}
                    <span style="float: right">{{
                      stat.team2Value | transliterate(cookiesObject.lang)
                    }}</span>
                  </p>
                  <p
                    style="height: 0px"
                    v-else-if="stat.statisticKey == 'offsides'"
                  >
                    <span style="float: left">{{
                      stat.team1Value | transliterate(cookiesObject.lang)
                    }}</span>
                    {{ $t("LanguageEn.statisticOffsides") }}
                    <span style="float: right">{{
                      stat.team2Value | transliterate(cookiesObject.lang)
                    }}</span>
                  </p>
                  <p
                    style="height: 0px"
                    v-else-if="stat.statisticKey == 'passes_accurate'"
                  >
                    <span style="float: left">{{
                      stat.team1Value | transliterate(cookiesObject.lang)
                    }}</span>
                    {{ $t("LanguageEn.statisticPassesAccurate") }}
                    <span style="float: right">{{
                      stat.team2Value | transliterate(cookiesObject.lang)
                    }}</span>
                  </p>
                  <p
                    style="height: 0px"
                    v-else-if="stat.statisticKey == 'passes_percentage'"
                  >
                    <span style="float: left">{{
                      stat.team1Value | transliterate(cookiesObject.lang)
                    }}</span>
                    {{ $t("LanguageEn.statisticPassesPercentage") }}
                    <span style="float: right">{{
                      stat.team2Value | transliterate(cookiesObject.lang)
                    }}</span>
                  </p>
                  <p
                    style="height: 0px"
                    v-else-if="stat.statisticKey == 'passes_total'"
                  >
                    <span style="float: left">{{
                      stat.team1Value | transliterate(cookiesObject.lang)
                    }}</span>
                    {{ $t("LanguageEn.statisticPassesTotal") }}
                    <span style="float: right">{{
                      stat.team2Value | transliterate(cookiesObject.lang)
                    }}</span>
                  </p>
                  <p
                    style="height: 0px"
                    v-else-if="stat.statisticKey == 'penalties'"
                  >
                    <span style="float: left">{{
                      stat.team1Value | transliterate(cookiesObject.lang)
                    }}</span>
                    {{ $t("LanguageEn.statisticPenalties") }}
                    <span style="float: right">{{
                      stat.team2Value | transliterate(cookiesObject.lang)
                    }}</span>
                  </p>
                  <p
                    style="height: 0px"
                    v-else-if="stat.statisticKey == 'possession_time'"
                  >
                    <span style="float: left"
                      >{{
                        stat.team1Value | transliterate(cookiesObject.lang)
                      }}%</span
                    >
                    {{ $t("LanguageEn.statisticPossessionTime") }}
                    <span style="float: right"
                      >{{
                        stat.team2Value | transliterate(cookiesObject.lang)
                      }}%</span
                    >
                  </p>
                  <p
                    style="height: 0px"
                    v-else-if="stat.statisticKey == 'red_cards'"
                  >
                    <span style="float: left">{{
                      stat.team1Value | transliterate(cookiesObject.lang)
                    }}</span>
                    {{ $t("LanguageEn.statisticRedCards") }}
                    <span style="float: right">{{
                      stat.team2Value | transliterate(cookiesObject.lang)
                    }}</span>
                  </p>
                  <p
                    style="height: 0px"
                    v-else-if="stat.statisticKey == 'saves'"
                  >
                    <span style="float: left">{{
                      stat.team1Value | transliterate(cookiesObject.lang)
                    }}</span
                    >{{ $t("LanguageEn.statisticSaves") }}
                    <span style="float: right">{{
                      stat.team2Value | transliterate(cookiesObject.lang)
                    }}</span>
                  </p>
                  <p
                    style="height: 0px"
                    v-else-if="stat.statisticKey == 'shots_blocked'"
                  >
                    <span style="float: left">{{
                      stat.team1Value | transliterate(cookiesObject.lang)
                    }}</span>
                    {{ $t("LanguageEn.statisticShotsBlocked") }}
                    <span style="float: right">{{
                      stat.team2Value | transliterate(cookiesObject.lang)
                    }}</span>
                  </p>
                  <p
                    style="height: 0px"
                    v-else-if="stat.statisticKey == 'shots_insidebox'"
                  >
                    <span style="float: left">{{
                      stat.team1Value | transliterate(cookiesObject.lang)
                    }}</span>
                    {{ $t("LanguageEn.statisticShotsInsidebox") }}
                    <span style="float: right">{{
                      stat.team2Value | transliterate(cookiesObject.lang)
                    }}</span>
                  </p>
                  <p
                    style="height: 0px"
                    v-else-if="stat.statisticKey == 'shots_offgoal'"
                  >
                    <span style="float: left">{{
                      stat.team1Value | transliterate(cookiesObject.lang)
                    }}</span>
                    {{ $t("LanguageEn.statisticShotsOffGoal") }}
                    <span style="float: right">{{
                      stat.team2Value | transliterate(cookiesObject.lang)
                    }}</span>
                  </p>
                  <p
                    style="height: 0px"
                    v-else-if="stat.statisticKey == 'shots_ongoal'"
                  >
                    <span style="float: left">{{
                      stat.team1Value | transliterate(cookiesObject.lang)
                    }}</span>
                    {{ $t("LanguageEn.statisticShotsOnGoal") }}
                    <span style="float: right">{{
                      stat.team2Value | transliterate(cookiesObject.lang)
                    }}</span>
                  </p>
                  <p
                    style="height: 0px"
                    v-else-if="stat.statisticKey == 'shots_outsidebox'"
                  >
                    <span style="float: left">{{
                      stat.team1Value | transliterate(cookiesObject.lang)
                    }}</span>
                    {{ $t("LanguageEn.statisticShotsOutsidebox") }}
                    <span style="float: right">{{
                      stat.team2Value | transliterate(cookiesObject.lang)
                    }}</span>
                  </p>
                  <p
                    style="height: 0px"
                    v-else-if="stat.statisticKey == 'shots_total'"
                  >
                    <span style="float: left">{{
                      stat.team1Value | transliterate(cookiesObject.lang)
                    }}</span>
                    {{ $t("LanguageEn.statisticShotsTotal") }}
                    <span style="float: right">{{
                      stat.team2Value | transliterate(cookiesObject.lang)
                    }}</span>
                  </p>
                  <p
                    style="height: 0px"
                    v-else-if="stat.statisticKey == 'substitutions'"
                  >
                    <span style="float: left">{{
                      stat.team1Value | transliterate(cookiesObject.lang)
                    }}</span>
                    {{ $t("LanguageEn.statisticSubstitution") }}
                    <span style="float: right">{{
                      stat.team2Value | transliterate(cookiesObject.lang)
                    }}</span>
                  </p>
                  <p
                    style="height: 0px"
                    v-else-if="stat.statisticKey == 'yellow_cards'"
                  >
                    <span style="float: left">{{
                      stat.team1Value | transliterate(cookiesObject.lang)
                    }}</span>
                    {{ $t("LanguageEn.statisticYellowCard") }}
                    <span style="float: right">{{
                      stat.team2Value | transliterate(cookiesObject.lang)
                    }}</span>
                  </p>
                  <p
                    style="height: 0px"
                    v-else-if="stat.statisticKey == 'yellow_red_cards'"
                  >
                    <span style="float: left">{{
                      stat.team1Value | transliterate(cookiesObject.lang)
                    }}</span>
                    {{ $t("LanguageEn.statisticYellowRedCards") }}
                    <span style="float: right">{{
                      stat.team2Value | transliterate(cookiesObject.lang)
                    }}</span>
                  </p>
                  <p style="height: 0px" v-else>
                    {{ stat.statisticKey | transliterate(cookiesObject.lang) }}
                  </p>
                </li>
                <li
                  class="list-group-item"
                  style="border: none; background: #141416"
                >
                  <b-progress
                    class=""
                    :max="200"
                    style="
                      border-radius: 0px;
                      height: 10px;
                      background: #2c2d31;
                    "
                  >
                    <b-progress-bar
                      style="font-weight: 800px; background: #2c2d31"
                      :value="
                        100 -
                        (stat.team1Value /
                          (stat.team1Value + stat.team2Value)) *
                          100
                      "
                      variant=""
                    ></b-progress-bar>
                    <b-progress-bar
                      style="font-weight: 800px; background: #5c5c5e"
                      v-bind:class="{ ybg: stat.team1Value > stat.team2Value }"
                      :value="
                        (stat.team1Value /
                          (stat.team1Value + stat.team2Value)) *
                        100
                      "
                      variant=""
                    ></b-progress-bar>
                    <b-progress-bar
                      style="font-weight: 800px; background: #5c5c5e"
                      v-bind:class="{ ybg: stat.team2Value > stat.team1Value }"
                      :value="
                        (stat.team2Value /
                          (stat.team1Value + stat.team2Value)) *
                        100
                      "
                    ></b-progress-bar>
                    <b-progress-bar
                      style="font-weight: 800px; background: #2c2d31"
                      :value="
                        100 -
                        (stat.team2Value /
                          (stat.team1Value + stat.team2Value)) *
                          100
                      "
                      variant=""
                    ></b-progress-bar>
                  </b-progress>
                </li>
              </div>
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <p
                  style="
                    margin: 0px;
                    font-weight: 550;
                    color: #e6e6e6;
                    font-size: 11px;
                  "
                >
                  {{ $t("LanguageEn.comments") }}
                </p>
              </template>
              <div>
                <div>
                  <b-overlay
                    no-center
                    :show="Overlay"
                    variant="light"
                    opacity="0.6"
                    style=""
                  >
                    <div
                      class=""
                      style="
                        height: 12px !important;
                        background: #141416 !important;
                      "
                    ></div>
                    <li
                      class="list-group-item listHeader"
                      style="border-radius: 0px; text-align: left"
                      v-if="MatchStats.match.commentaries.length !== 0"
                    >
                      <span style="cursor: pointer">
                        <span
                          @click="comShow = 1"
                          v-bind:class="{ uline: comShow == 1 }"
                          >{{ $t("LanguageEn.allComm") }}
                        </span>
                        <span
                          v-bind:class="{ uline: comShow == 2 }"
                          @click="comShow = 2"
                          style="margin-left: 10px"
                        >
                          {{ $t("LanguageEn.impComm") }}
                        </span>
                      </span>
                    </li>
                    <li
                      class="list-group-item"
                      style="
                        border-radius: 0px;
                        text-align: left;
                        background: #212225;
                        font-size: 13px;
                      "
                      v-if="MatchStats.match.commentaries.length !== 0"
                    >
                      <span style="margin-right: 3px"
                        >{{ $t("LanguageEn.cLang") }}
                      </span>
                      <span
                        v-for="(lang, i) in languages"
                        :key="lang.id"
                        @click="translate(lang.id), (ss = lang.id)"
                        style="cursor: pointer"
                        v-bind:class="{ slang: lang.id == ss }"
                      >
                        {{ lang.name }}
                        <span v-if="i + 1 < languages.length">, </span>
                      </span>
                    </li>
                    <li
                      class="list-group-item"
                      style="
                        border-radius: 0px;
                        background: #1a1a1d;
                        font-size: 13px;
                        text-align: center;
                      "
                      v-if="MatchStats.match.commentaries.length == 0"
                    >
                      <img
                        style="margin-bottom: 3px"
                        src="@/assets/noInfo.svg"
                        v-if="MatchStats.match.matchStatus.name == 'NS'"
                      /><img
                        style="margin-bottom: 3px"
                        src="@/assets/noLine.svg"
                        v-else
                      />
                      {{ $t("LanguageEn.noInfo") }}
                    </li>
                    <div
                      v-for="comment in comms"
                      :key="comment.id"
                      style="color: #e6e6e6"
                    >
                      <li
                        class="list-group-item"
                        style="
                          border-bottom: 1px solid #2c2d31;
                          border-top: none;
                          border-left: none;
                          border-right: none;
                          background: #141416;
                          font-size: 11px;
                        "
                        v-if="comment.important == 1 && comShow == 2"
                      >
                        <span v-bind:class="{ import: comment.important == 1 }">
                          <div class="row">
                            <span class="col-1" v-if="comment.minute > 9"
                              >{{ comment.minute }}'</span
                            >
                            <span class="col-1" v-else
                              >0{{ comment.minute }}'</span
                            >
                            <span
                              class="col"
                              style="
                                margin-left: 5px;
                                line-height: 1.3;
                                border-left: 1px solid #2c2d31;
                              "
                              ><img
                                style="width: 20px"
                                src="@/assets/goalBig.png"
                                v-if="comment.goal == 1"
                              />
                              {{
                                comment.comment
                                  | transliterate(cookiesObject.lang)
                              }}</span
                            >
                          </div>
                        </span>
                      </li>
                      <li
                        class="list-group-item"
                        style="
                          border-bottom: 1px solid #2c2d31;
                          border-top: none;
                          border-left: none;
                          border-right: none;
                          background: #141416;
                          font-size: 11px;
                        "
                        v-if="comShow == 1"
                      >
                        <span v-bind:class="{ import: comment.important == 1 }">
                          <div class="row">
                            <span class="col-1" v-if="comment.minute > 9"
                              >{{ comment.minute }}'</span
                            >
                            <span class="col-1" v-else
                              >0{{ comment.minute }}'</span
                            >
                            <span
                              class="col"
                              style="
                                margin-left: 5px;
                                line-height: 1.3;
                                border-left: 1px solid #2c2d31;
                              "
                              ><img
                                style="width: 20px"
                                src="@/assets/goalBig.png"
                                v-if="comment.goal == 1"
                              />
                              {{
                                comment.comment
                                  | transliterate(cookiesObject.lang)
                              }}</span
                            >
                          </div>
                        </span>
                      </li>
                    </div>
                  </b-overlay>
                </div>
              </div>
            </b-tab>
          </b-tabs>

          <!-- Inner tabs end -->
        </b-tab>
        <b-tab
          v-if="MatchStats.match"
          style="border-radius: 0px; background: #212529"
          lazy
        >
          <template v-slot:title>
            <img
              style="width: 20px"
              src="@/assets/matchpageNavbar/h2ha.svg"
              v-if="tabIndex == 1"
            />
            <img
              style="width: 20px"
              src="@/assets/matchpageNavbar/h2h.svg"
              v-else
            />
            <br />
            <p
              style="
                margin: 0px;
                font-weight: 550;
                color: white;
                font-size: 12px;
              "
              v-if="tabIndex == 1"
            >
              {{ "H2H" | transliterate(cookiesObject.lang) }}
            </p>
            <p
              style="
                margin: 0px;
                font-weight: 550;
                color: grey;
                font-size: 12px;
              "
              v-else
            >
              {{ "H2H" | transliterate(cookiesObject.lang) }}
            </p>
          </template>
          <div>
            <div
              class=""
              style="height: 12px !important; background: #141416 !important"
            ></div>
            <li
              class="list-group-item MobileHide"
              style="
                line-height: 5px;
                text-align: left;
                font-size: 14px;
                color: lightgrey;
                font-weight: 550;
                background: #212225;
              "
            >
              {{ $t("LanguageEn.h2hMatches") }}:
              {{
                MatchStats.match.team1.name | transliterate(cookiesObject.lang)
              }}
              -
              {{
                MatchStats.match.team2.name | transliterate(cookiesObject.lang)
              }}
            </li>
            <div v-for="game in gamesTween.matches" :key="game.idq">
              <ul
                class="list-group Info pl-0 pr-0"
                style="border-radius: 0px"
                v-if="game.matchStatus.name !== 'NS'"
              >
                <li
                  v-on:click="(id = game.id), emitToParent()"
                  class="list-group-item MobileHide"
                  style="
                    cursor: pointer;
                    font-size: 14px;
                    height: 40px;
                    background: #141416;
                    border-bottom: 1px solid #212225;
                    border-top: none;
                    border-right: none;
                    border-left: none;
                  "
                >
                  <div class="row" style="">
                    <div class="col-2" style="color: grey">
                      {{
                        game.matchTime.slice(2, -9).split("-")[2]
                          | transliterate(cookiesObject.lang)
                      }}.{{
                        game.matchTime.slice(2, -9).split("-")[1]
                          | transliterate(cookiesObject.lang)
                      }}.{{
                        game.matchTime.slice(2, -9).split("-")[0]
                          | transliterate(cookiesObject.lang)
                      }}
                    </div>
                    <div class="col-1" style="">
                      <img
                        :src="
                          'https://sportapi.zuniac.com/tournament/logo/' +
                          game.tournament.id
                        "
                        style="
                          width: 20px;
                          background: white;
                          border-radius: 50%;
                        "
                        alt=""
                      />
                    </div>
                    <div class="col" style="font-weight: 550; color: lightgrey">
                      <p class="row">
                        <span
                          class="col"
                          v-bind:class="{ gwg: game.winner == 1 }"
                          >{{
                            game.team1.name | transliterate(cookiesObject.lang)
                          }}</span
                        >
                        <span
                          class="col"
                          v-bind:class="{ gwg: game.winner == 2 }"
                          >{{
                            game.team2.name | transliterate(cookiesObject.lang)
                          }}</span
                        >
                      </p>
                    </div>
                    <div class="col-1">
                      <p style="letter-spacing: 4px">
                        {{
                          game.currentScore.split("-")[0]
                            | transliterate(cookiesObject.lang)
                        }}:{{
                          game.currentScore.split("-")[1]
                            | transliterate(cookiesObject.lang)
                        }}
                      </p>
                    </div>
                  </div>
                </li>
                <li
                  v-on:click="(id = game.id), emitToParent()"
                  class="list-group-item MobileShow"
                  style="
                    cursor: pointer;
                    font-size: 14px;
                    height: 60px;
                    background: #141416;
                    border-bottom: 1px solid #212225;
                    border-top: none;
                    border-right: none;
                    border-left: none;
                  "
                >
                  <div class="row" style="">
                    <div
                      class="col-2 pl-0 pr-0"
                      style="color: grey; margin-top: 7px"
                    >
                      {{
                        game.matchTime.slice(2, -9).split("-")[2]
                          | transliterate(cookiesObject.lang)
                      }}.{{
                        game.matchTime.slice(2, -9).split("-")[1]
                          | transliterate(cookiesObject.lang)
                      }}.{{
                        game.matchTime.slice(2, -9).split("-")[0]
                          | transliterate(cookiesObject.lang)
                      }}
                    </div>
                    <div class="col-1" style="margin-top: 7px">
                      <img
                        :src="
                          'https://sportapi.zuniac.com/tournament/logo/' +
                          game.tournament.id
                        "
                        style="
                          width: 20px;
                          background: white;
                          border-radius: 50%;
                        "
                        alt=""
                      />
                    </div>
                    <div
                      class="col"
                      style="
                        font-weight: 500;
                        color: lightgrey;
                        margin-top: -5px;
                      "
                    >
                      <div class="col" v-bind:class="{ gwg: game.winner == 1 }">
                        {{
                          game.team1.name | transliterate(cookiesObject.lang)
                        }}
                      </div>
                      <br />
                      <div class="col" v-bind:class="{ gwg: game.winner == 2 }">
                        {{
                          game.team2.name | transliterate(cookiesObject.lang)
                        }}
                      </div>
                    </div>
                    <div class="col-2" style="margin-top: 7px">
                      <p style="letter-spacing: 4px">
                        {{
                          game.currentScore.split("-")[0]
                            | transliterate(cookiesObject.lang)
                        }}:{{
                          game.currentScore.split("-")[1]
                            | transliterate(cookiesObject.lang)
                        }}
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </b-tab>
        <b-tab
          v-if="MatchStats.match"
          style="border-radius: 0px; background: #212529"
          lazy
        >
          <template v-slot:title>
            <img
              style="width: 20px"
              src="@/assets/matchpageNavbar/tablea.svg"
              v-if="tabIndex == 2"
            />
            <img
              style="width: 20px"
              src="@/assets/matchpageNavbar/table.svg"
              v-else
            />
            <br />
            <p
              style="
                margin: 0px;
                font-weight: 550;
                color: white;
                font-size: 12px;
              "
              v-if="tabIndex == 2"
            >
              {{ $t("LanguageEn.txtTable") }}
            </p>
            <p
              style="
                margin: 0px;
                font-weight: 550;
                color: grey;
                font-size: 12px;
              "
              v-else
            >
              {{ $t("LanguageEn.txtTable") }}
            </p>
          </template>
          <div>
            <div
              class=""
              style="height: 12px !important; background: #141416 !important"
            ></div>
            <li
              class="list-group-item"
              style="
                border-radius: 0px;
                background: #1a1a1d;
                font-size: 13px;
                text-align: center;
              "
              v-if="leagueTable.length == 0"
            >
              <img
                style="margin-bottom: 3px"
                src="@/assets/noInfo.svg"
                v-if="MatchStats.match.matchStatus.name == 'NS'"
              /><img
                style="margin-bottom: 3px"
                src="@/assets/noLine.svg"
                v-else
              />
              {{ $t("LanguageEn.noInfo") }}
            </li>
            <ul class="list-group pl-0 pr-0" v-else>
              <li
                class="list-group-item MobileHide"
                style="
                  color: white;
                  background: #212225;
                  border-radius: 0px;
                  font-size: 12px;
                "
                v-if="!leagueTable[0].groupName"
              >
                <div class="row">
                  <div class="col">#</div>
                  <div class="col-6">
                    {{ $t("LanguageEn.txtTeam") }}
                  </div>
                  <div class="col">
                    {{ $t("LanguageEn.txtTableCount") }}
                  </div>
                  <div class="col">
                    {{ $t("LanguageEn.txtTableWin") }}
                  </div>
                  <div class="col">
                    {{ $t("LanguageEn.txtTableDraw") }}
                  </div>
                  <div class="col">
                    {{ $t("LanguageEn.txtTableLose") }}
                  </div>
                  <div class="col">
                    {{ $t("LanguageEn.txtTableGoals") }}
                  </div>
                  <div class="col">
                    {{ $t("LanguageEn.txtTablePoint") }}
                  </div>
                </div>
              </li>
              <li
                class="list-group-item MobileShow Some"
                style="color: #e6e6e6; background: #2c2d31; font-size: 12px"
                v-if="!leagueTable[0].groupName"
              >
                <div class="row">
                  <div class="col">#</div>
                  <div class="col-4">
                    {{ $t("LanguageEn.txtTeam") }}
                  </div>
                  <div class="col pr-2 pl-2">
                    {{ $t("LanguageEn.txtTableCount") }}
                  </div>
                  <div class="col pr-2 pl-2">
                    {{ $t("LanguageEn.txtTableWin") }}
                  </div>
                  <div class="col pr-2 pl-2">
                    {{ $t("LanguageEn.txtTableDraw") }}
                  </div>
                  <div class="col pr-2 pl-2">
                    {{ $t("LanguageEn.txtTableLose") }}
                  </div>
                  <div class="col pr-2 pl-2">
                    {{ $t("LanguageEn.txtTableGoals") }}
                  </div>
                  <div class="col pr-2 pl-2">
                    {{ $t("LanguageEn.txtTablePoint") }}
                  </div>
                </div>
              </li>
              <div v-if="gs.length > 0">
                <div
                  v-for="table in standings1"
                  :key="table.idll"
                  class="MobileHide"
                >
                  <div
                    v-for="(group, i) in table"
                    :key="group.id"
                    class="MobileHide"
                  >
                    <li
                      class="list-group-item header MobileHide"
                      style="
                        background: #212225;
                        font-size: 12px;
                        margin-top: 0px;
                        margin-bottom: 0px;
                        color: white;
                        text-align: center;
                        line-height: 5px;
                      "
                      v-if="i < 1 && group.groupName"
                    >
                      <div class="row">
                        <div class="col">#</div>
                        <div class="col-6" style="text-align: left">
                          {{
                            group.groupName | transliterate(cookiesObject.lang)
                          }}
                        </div>
                        <div class="col">
                          {{ $t("LanguageEn.txtTableCount") }}
                        </div>
                        <div class="col">
                          {{ $t("LanguageEn.txtTableWin") }}
                        </div>
                        <div class="col">
                          {{ $t("LanguageEn.txtTableDraw") }}
                        </div>
                        <div class="col">
                          {{ $t("LanguageEn.txtTableLose") }}
                        </div>
                        <div class="col">
                          {{ $t("LanguageEn.txtTableGoals") }}
                        </div>
                        <div class="col">
                          {{ $t("LanguageEn.txtTablePoint") }}
                        </div>
                      </div>
                    </li>
                    <li
                      style="
                        height: 35px;
                        color: white !important;
                        font-size: 13px;
                        background: #141416;
                        border: none;
                      "
                      class="list-group-item"
                      v-bind:class="{
                        yellowBg:
                          group.team.name == team1name ||
                          group.team.name == team2name,
                      }"
                    >
                      <router-link
                        style="text-decoration: none; color: white !important"
                        id="router-link"
                        :to="{
                          name: 'teamPage',
                          params: { id: group.team.id, name: group.team.name },
                        }"
                        ><div class="row">
                          <div
                            class="col"
                            style="
                              color: white;
                              background: #3c3e43;
                              height: 35px;
                              margin-top: -12px;
                              text-align: center;
                              border-bottom: 1px solid black;
                            "
                          >
                            <p style="margin-top: 11px">
                              {{
                                group.position
                                  | transliterate(cookiesObject.lang)
                              }}
                            </p>
                          </div>
                          <div
                            class="col-6"
                            style="
                              color: white;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            <img
                              :src="teamLogo + group.team.id"
                              alt=""
                              style="
                                width: 17px;
                                margin-right: 5px;
                                margin-bottom: 3px;
                              "
                            />
                            {{
                              group.team.name
                                | transliterate(cookiesObject.lang)
                            }}
                          </div>
                          <div
                            class="col"
                            style="
                              color: white;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            {{
                              group.gameCount
                                | transliterate(cookiesObject.lang)
                            }}
                          </div>
                          <div
                            class="col"
                            style="
                              color: white;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            {{ group.win | transliterate(cookiesObject.lang) }}
                          </div>
                          <div
                            class="col"
                            style="
                              color: white;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            {{ group.draw | transliterate(cookiesObject.lang) }}
                          </div>
                          <div
                            class="col"
                            style="
                              color: white;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            {{ group.lose | transliterate(cookiesObject.lang) }}
                          </div>
                          <div
                            class="col"
                            style="
                              color: white;
                              text-align: center;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            {{
                              (group.goalScored - group.goalAgainst)
                                | transliterate(cookiesObject.lang)
                            }}
                          </div>
                          <div
                            class="col"
                            style="
                              color: white;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            {{
                              group.points | transliterate(cookiesObject.lang)
                            }}
                          </div>
                        </div></router-link
                      >
                    </li>
                  </div>
                </div>
              </div>
              <div v-if="rs.length > 0">
                <div
                  v-for="table in standings"
                  :key="table.idll"
                  class="MobileHide"
                >
                  <div
                    v-for="(group, i) in table"
                    :key="group.id"
                    class="MobileHide"
                  >
                    <li
                      class="list-group-item header MobileHide"
                      style="
                        background: #212225;
                        font-size: 12px;
                        margin-top: 0px;
                        margin-bottom: 0px;
                        color: white;
                        text-align: center;
                        line-height: 5px;
                      "
                      v-if="i < 1 && group.groupName"
                    >
                      <div class="row">
                        <div class="col">#</div>
                        <div class="col-6" style="text-align: left">
                          {{
                            group.groupName | transliterate(cookiesObject.lang)
                          }}
                        </div>
                        <div class="col">
                          {{ $t("LanguageEn.txtTableCount") }}
                        </div>
                        <div class="col">
                          {{ $t("LanguageEn.txtTableWin") }}
                        </div>
                        <div class="col">
                          {{ $t("LanguageEn.txtTableDraw") }}
                        </div>
                        <div class="col">
                          {{ $t("LanguageEn.txtTableLose") }}
                        </div>
                        <div class="col">
                          {{ $t("LanguageEn.txtTableGoals") }}
                        </div>
                        <div class="col">
                          {{ $t("LanguageEn.txtTablePoint") }}
                        </div>
                      </div>
                    </li>
                    <li
                      style="
                        height: 35px;
                        color: white !important;
                        font-size: 13px;
                        background: #141416;
                        border: none;
                      "
                      class="list-group-item"
                      v-bind:class="{
                        yellowBg:
                          group.team.name == team1name ||
                          group.team.name == team2name,
                      }"
                    >
                      <router-link
                        style="text-decoration: none; color: white !important"
                        id="router-link"
                        :to="{
                          name: 'teamPage',
                          params: { id: group.team.id, name: group.team.name },
                        }"
                        ><div class="row">
                          <div
                            class="col"
                            style="
                              color: white;
                              background: #3c3e43;
                              height: 35px;
                              margin-top: -12px;
                              text-align: center;
                              border-bottom: 1px solid black;
                            "
                          >
                            <p style="margin-top: 11px">
                              {{
                                group.position
                                  | transliterate(cookiesObject.lang)
                              }}
                            </p>
                          </div>
                          <div
                            class="col-6"
                            style="
                              color: white;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            <img
                              :src="teamLogo + group.team.id"
                              alt=""
                              style="
                                width: 17px;
                                margin-right: 5px;
                                margin-bottom: 3px;
                              "
                            />
                            {{
                              group.team.name
                                | transliterate(cookiesObject.lang)
                            }}
                          </div>
                          <div
                            class="col"
                            style="
                              color: white;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            {{
                              group.gameCount
                                | transliterate(cookiesObject.lang)
                            }}
                          </div>
                          <div
                            class="col"
                            style="
                              color: white;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            {{ group.win | transliterate(cookiesObject.lang) }}
                          </div>
                          <div
                            class="col"
                            style="
                              color: white;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            {{ group.draw | transliterate(cookiesObject.lang) }}
                          </div>
                          <div
                            class="col"
                            style="
                              color: white;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            {{ group.lose | transliterate(cookiesObject.lang) }}
                          </div>
                          <div
                            class="col"
                            style="
                              color: white;
                              text-align: center;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            {{
                              (group.goalScored - group.goalAgainst)
                                | transliterate(cookiesObject.lang)
                            }}
                          </div>
                          <div
                            class="col"
                            style="
                              color: white;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            {{
                              group.points | transliterate(cookiesObject.lang)
                            }}
                          </div>
                        </div></router-link
                      >
                    </li>
                  </div>
                </div>
              </div>
              <div v-if="gs.length > 0">
                <div
                  v-for="table in standings1"
                  :key="table.idll"
                  class="MobileShow"
                >
                  <div
                    v-for="(group, i) in table"
                    :key="group.id"
                    class="MobileShow"
                  >
                    <li
                      class="list-group-item header MobileShow"
                      style="
                        background: #212225;
                        font-size: 13px;
                        margin-top: 0px;
                        margin-bottom: 0px;
                        color: white;
                        text-align: center;
                        line-height: 5px;
                      "
                      v-if="i < 1 && group.groupName"
                    >
                      <div class="row">
                        <div class="col">#</div>
                        <div class="col-4" style="text-align: left">
                          {{ group.groupName }}
                        </div>
                        <div class="col pr-2 pl-2">
                          {{ $t("LanguageEn.txtTableCount") }}
                        </div>
                        <div class="col pr-2 pl-2">
                          {{ $t("LanguageEn.txtTableWin") }}
                        </div>
                        <div class="col pr-2 pl-2">
                          {{ $t("LanguageEn.txtTableDraw") }}
                        </div>
                        <div class="col pr-2 pl-2">
                          {{ $t("LanguageEn.txtTableLose") }}
                        </div>
                        <div class="col pr-2 pl-2">
                          {{ $t("LanguageEn.txtTableGoals") }}
                        </div>
                        <div class="col pr-2 pl-2">
                          {{ $t("LanguageEn.txtTablePoint") }}
                        </div>
                      </div>
                    </li>
                    <li
                      style="
                        height: 35px;
                        border: none;
                        font-size: 11px;
                        background: #141416;
                      "
                      class="list-group-item"
                      v-bind:class="{
                        yellowBg:
                          group.team.name == team1name ||
                          group.team.name == team2name,
                      }"
                    >
                      <router-link
                        style="text-decoration: none"
                        id="router-link"
                        :to="{
                          name: 'teamPagePar',
                          params: { id: group.team.id },
                        }"
                        ><div class="row">
                          <div
                            class="col"
                            style="
                              color: #e6e6e6;
                              background: #3c3e43;
                              height: 35px;
                              margin-top: -12px;
                              text-align: left;
                              border-bottom: 1px solid black;
                            "
                          >
                            <p style="margin-top: 10px">
                              {{
                                group.position
                                  | transliterate(cookiesObject.lang)
                              }}
                            </p>
                          </div>
                          <div
                            class="col-4"
                            style="
                              color: #e6e6e6;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            <img
                              :src="teamLogo + group.team.id"
                              alt=""
                              style="
                                width: 17px;
                                margin-right: 5px;
                                margin-bottom: 3px;
                              "
                            />
                            <span v-if="group.team.shortCode">{{
                              group.team.shortCode
                                | transliterate(cookiesObject.lang)
                            }}</span
                            ><span v-else>{{
                              group.team.name.slice(0, 3).toUpperCase()
                                | transliterate(cookiesObject.lang)
                            }}</span>
                          </div>
                          <div
                            class="col pr-2 pl-2"
                            style="
                              color: #e6e6e6;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            {{
                              group.gameCount
                                | transliterate(cookiesObject.lang)
                            }}
                          </div>
                          <div
                            class="col pr-2 pl-2"
                            style="
                              color: #e6e6e6;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            {{ group.win | transliterate(cookiesObject.lang) }}
                          </div>
                          <div
                            class="col pr-2 pl-2"
                            style="
                              color: #e6e6e6;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            {{ group.draw | transliterate(cookiesObject.lang) }}
                          </div>
                          <div
                            class="col pr-2 pl-2"
                            style="
                              color: #e6e6e6;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            {{ group.lose | transliterate(cookiesObject.lang) }}
                          </div>
                          <div
                            class="col pr-2 pl-2"
                            style="
                              color: #e6e6e6;
                              text-align: center;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            {{
                              (group.goalScored - group.goalAgainst)
                                | transliterate(cookiesObject.lang)
                            }}
                          </div>
                          <div
                            class="col pr-2 pl-2"
                            style="
                              color: #e6e6e6;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            {{
                              group.points | transliterate(cookiesObject.lang)
                            }}
                          </div>
                        </div></router-link
                      >
                    </li>
                  </div>
                </div>
              </div>
              <div v-if="rs.length > 0">
                <div
                  v-for="table in standings"
                  :key="table.idll"
                  class="MobileShow"
                >
                  <div
                    v-for="(group, i) in table"
                    :key="group.id"
                    class="MobileShow"
                  >
                    <li
                      class="list-group-item header MobileShow"
                      style="
                        background: #212225;
                        font-size: 13px;
                        margin-top: 0px;
                        margin-bottom: 0px;
                        color: white;
                        text-align: center;
                        line-height: 5px;
                      "
                      v-if="i < 1 && group.groupName"
                    >
                      <div class="row">
                        <div class="col">#</div>
                        <div class="col-4" style="text-align: left">
                          {{
                            group.groupName | transliterate(cookiesObject.lang)
                          }}
                        </div>
                        <div class="col pr-2 pl-2">
                          {{ $t("LanguageEn.txtTableCount") }}
                        </div>
                        <div class="col pr-2 pl-2">
                          {{ $t("LanguageEn.txtTableWin") }}
                        </div>
                        <div class="col pr-2 pl-2">
                          {{ $t("LanguageEn.txtTableDraw") }}
                        </div>
                        <div class="col pr-2 pl-2">
                          {{ $t("LanguageEn.txtTableLose") }}
                        </div>
                        <div class="col pr-2 pl-2">
                          {{ $t("LanguageEn.txtTableGoals") }}
                        </div>
                        <div class="col pr-2 pl-2">
                          {{ $t("LanguageEn.txtTablePoint") }}
                        </div>
                      </div>
                    </li>
                    <li
                      style="
                        height: 35px;
                        border: none;
                        font-size: 11px;
                        background: #141416;
                      "
                      class="list-group-item"
                      v-bind:class="{
                        yellowBg:
                          group.team.name == team1name ||
                          group.team.name == team2name,
                      }"
                    >
                      <router-link
                        style="text-decoration: none"
                        id="router-link"
                        :to="{
                          name: 'teamPagePar',
                          params: { id: group.team.id },
                        }"
                        ><div class="row">
                          <div
                            class="col"
                            style="
                              color: #e6e6e6;
                              background: #3c3e43;
                              height: 35px;
                              margin-top: -12px;
                              text-align: left;
                              border-bottom: 1px solid black;
                            "
                          >
                            <p style="margin-top: 10px">
                              {{
                                group.position
                                  | transliterate(cookiesObject.lang)
                              }}
                            </p>
                          </div>
                          <div
                            class="col-4"
                            style="
                              color: #e6e6e6;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            <img
                              :src="teamLogo + group.team.id"
                              alt=""
                              style="
                                width: 17px;
                                margin-right: 5px;
                                margin-bottom: 3px;
                              "
                            />
                            <span v-if="group.team.shortCode">{{
                              group.team.shortCode
                                | transliterate(cookiesObject.lang)
                            }}</span
                            ><span v-else>{{
                              group.team.name.slice(0, 3).toUpperCase()
                                | transliterate(cookiesObject.lang)
                            }}</span>
                          </div>
                          <div
                            class="col pr-2 pl-2"
                            style="
                              color: #e6e6e6;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            {{
                              group.gameCount
                                | transliterate(cookiesObject.lang)
                            }}
                          </div>
                          <div
                            class="col pr-2 pl-2"
                            style="
                              color: #e6e6e6;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            {{ group.win | transliterate(cookiesObject.lang) }}
                          </div>
                          <div
                            class="col pr-2 pl-2"
                            style="
                              color: #e6e6e6;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            {{ group.draw | transliterate(cookiesObject.lang) }}
                          </div>
                          <div
                            class="col pr-2 pl-2"
                            style="
                              color: #e6e6e6;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            {{ group.lose | transliterate(cookiesObject.lang) }}
                          </div>
                          <div
                            class="col pr-2 pl-2"
                            style="
                              color: #e6e6e6;
                              text-align: center;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            {{
                              (group.goalScored - group.goalAgainst)
                                | transliterate(cookiesObject.lang)
                            }}
                          </div>
                          <div
                            class="col pr-2 pl-2"
                            style="
                              color: #e6e6e6;
                              border-bottom: 1px solid #2c2d31;
                            "
                          >
                            {{
                              group.points | transliterate(cookiesObject.lang)
                            }}
                          </div>
                        </div></router-link
                      >
                    </li>
                  </div>
                </div>
              </div>
            </ul>
          </div>
        </b-tab>
        <b-tab
          v-if="MatchStats.match"
          style="border-radius: 0px; background: rgb(255, 255, 255)"
          lazy
        >
          <template v-slot:title>
            <img
              style="width: 20px"
              src="@/assets/matchpageNavbar/guessa.svg"
              v-if="tabIndex == 3"
            />
            <img
              style="width: 20px"
              src="@/assets/matchpageNavbar/guess.svg"
              v-else
            />
            <br />
            <p
              style="
                margin: 0px;
                font-weight: 550;
                color: white;
                font-size: 12px;
              "
              v-if="tabIndex == 3"
            >
              {{ $t("LanguageEn.guess") }}
            </p>
            <p
              style="
                margin: 0px;
                font-weight: 550;
                color: grey;
                font-size: 12px;
              "
              v-else
            >
              {{ $t("LanguageEn.guess") }}
            </p>
          </template>
          <div
            class=""
            style="height: 12px !important; background: #141416 !important"
          ></div>
          <li
            class="list-group-item"
            style="
              border-radius: 0px;
              background: #1a1a1d;
              font-size: 13px;
              text-align: center;
            "
            v-if="MatchStats.match.betEnabled == 0"
          >
            <img style="margin-bottom: 3px" src="@/assets/noInfo.svg" />{{
              $t("LanguageEn.pText")
            }}
          </li>
          <div v-else>
            <li
              class="list-group-item MobileHide"
              style="
                line-height: 5px;
                text-align: left;
                font-size: 14px;
                color: #e6e6e6;
                font-weight: 550;
                background: #212225;
              "
            >
              {{ $t("LanguageEn.guessTable") }}
            </li>
            <div
              class="predict"
              v-if="
                MatchStats.match.matchStatus.name == 'NS' &&
                pred.gamePredictions.length == 0
              "
              style="padding-top: 20px"
            >
              <div class="row" style="height: 150px">
                <div
                  class="col"
                  :style="rtl ? 'text-align: left;' : 'text-align: right;'"
                >
                  <div class="row">
                    <p
                      style="
                        font-weight: 500;
                        color: #e6e6e6;
                        font-size: 12px;
                        margin-top: 65px;
                      "
                      class="col pr-2 pl-3"
                    >
                      {{ team1name | transliterate(cookiesObject.lang) }}
                    </p>
                    <b-form-spinbutton
                      class=""
                      id="sb-vertical"
                      size="lg"
                      min="0"
                      max="20"
                      wrap
                      v-model="team1score"
                      vertical
                      style="
                        background: #212225;
                        border: none;
                        color: white;
                        border-radius: 3px;
                        height: 115px;
                        margin-top: 17px;
                      "
                    ></b-form-spinbutton>
                  </div>
                </div>
                <div
                  class="col-1 pl-0 pr-0"
                  :style="rtl ? 'text-align: left;' : 'text-align: right;'"
                >
                  <p style="color: #e6e6e6; margin-top: 65px">:</p>
                </div>
                <div
                  class="col"
                  :style="rtl ? 'text-align: left;' : 'text-align: right;'"
                >
                  <div class="row">
                    <b-form-spinbutton
                      class=""
                      id="sb-vertical2"
                      size="lg"
                      min="0"
                      max="20"
                      wrap
                      v-model="team2score"
                      vertical
                      style="
                        background: #212225;
                        border: none;
                        color: white;
                        border-radius: 3px;
                        height: 115px;
                        margin-top: 17px;
                      "
                    ></b-form-spinbutton>
                    <p
                      style="
                        font-weight: 500;
                        color: #e6e6e6;
                        font-size: 12px;
                        margin-top: 65px;
                      "
                      class="col pl-2 pr-3"
                    >
                      {{ team2name | transliterate(cookiesObject.lang) }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                style="
                  padding-top: 10px;
                  padding-bottom: 10px;
                  text-align: center;
                "
              >
                <b-btn
                  variant="success"
                  style="
                    width: 170px;
                    background: #18541d;
                    border: none;
                    border-radius: 1px;
                  "
                  @click="$refs['sure-modal'].show()"
                  >{{ $t("LanguageEn.guess") }}</b-btn
                >
              </div>
            </div>
            <div
              class="predict"
              v-else-if="
                MatchStats.match.matchStatus.name == 'NS' &&
                pred.gamePredictions.length !== 0
              "
            >
              <div
                style="
                  padding-bottom: 10px;
                  text-align: center;
                  font-size: 11px;
                "
              >
                <div
                  style="
                    background-image: linear-gradient(#a1a1a1, #5d5d5f);
                    border: none;
                    height: 34px;
                    line-height: 34px;
                    border-radius: 2px;
                  "
                >
                  <img
                    src="@/assets/guessWa.svg"
                    style="margin-bottom: 4px"
                    alt=""
                  />
                  {{ $t("LanguageEn.guessW") }}
                </div>
              </div>
              <div
                class="row"
                style="
                  font-size: 13px;
                  height: 60px;
                  line-height: 60px;
                  margin-top: 30px;
                  margin-bottom: 30px;
                  color: #e6e6e6;
                "
              >
                <div
                  class="col"
                  :style="rtl ? 'text-align: left;' : 'text-align: right;'"
                >
                  <div class="row">
                    <p class="col">
                      {{ team1name | transliterate(cookiesObject.lang) }}
                    </p>
                  </div>
                </div>
                <div
                  class="col"
                  :style="rtl ? 'text-align: left;' : 'text-align: right;'"
                >
                  <div class="row MobileHide" style="font-size: 21px">
                    <p
                      class="col ml-3"
                      style="
                        background: #212225;
                        border-radius: 2px;
                        border: 2px solid #27292c;
                        height: 60px;
                      "
                    >
                      {{
                        pred.gamePredictions[0].predictionValue.split("-")[0]
                          | transliterate(cookiesObject.lang)
                      }}
                    </p>
                    <p class="col pr-3 pl-3" style="background: ">-</p>
                    <p
                      class="col mr-3"
                      style="
                        background: #212225;
                        border-radius: 2px;
                        border: 2px solid #27292c;
                        height: 60px;
                      "
                    >
                      {{
                        pred.gamePredictions[0].predictionValue.split("-")[1]
                          | transliterate(cookiesObject.lang)
                      }}
                    </p>
                  </div>
                  <div class="MobileShow">
                    <p style="font-weight: 600; color: white" class="col">
                      {{
                        pred.gamePredictions[0].predictionValue
                          | transliterate(cookiesObject.lang)
                      }}
                    </p>
                  </div>
                </div>
                <div class="col" style="">
                  <div class="row">
                    <p style="font-weight: 600" class="col">
                      {{ team2name | transliterate(cookiesObject.lang) }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                v-if="pred.gamePredictions[0].calculation !== null"
                style="text-align: center; color: white"
              >
                <ul style="list-style-type: none; padding-left: 0px">
                  <li class="row container">
                    <span class="col pl-5" style="text-align: right">
                      bonus:
                    </span>
                    <span class="col" style="text-align: left">{{
                      pred.gamePredictions[0].calculation.bonus
                        | transliterate(cookiesObject.lang)
                    }}</span>
                  </li>
                  <li class="row container">
                    <span class="col pl-5" style="text-align: right">
                      result:
                    </span>
                    <span class="col" style="text-align: left">{{
                      pred.gamePredictions[0].calculation.result
                        | transliterate(cookiesObject.lang)
                    }}</span>
                  </li>
                  <li class="row container">
                    <span class="col pl-5" style="text-align: right">
                      match score:
                    </span>
                    <span class="col" style="text-align: left">{{
                      pred.gamePredictions[0].calculation.matchScore
                        | transliterate(cookiesObject.lang)
                    }}</span>
                  </li>
                  <li class="row container">
                    <span class="col pl-5" style="text-align: right">
                      total goals:
                    </span>
                    <span class="col" style="text-align: left">{{
                      pred.gamePredictions[0].calculation.totalGoals
                        | transliterate(cookiesObject.lang)
                    }}</span>
                  </li>
                  <li class="row container">
                    <span class="col pl-5" style="text-align: right">
                      Scored by away:
                    </span>
                    <span class="col" style="text-align: left">{{
                      pred.gamePredictions[0].calculation.goalsScoredByAway
                        | transliterate(cookiesObject.lang)
                    }}</span>
                  </li>
                  <li class="row container">
                    <span class="col pl-5" style="text-align: right">
                      Scored by home:
                    </span>
                    <span class="col" style="text-align: left">{{
                      pred.gamePredictions[0].calculation.goalsScoredByHome
                        | transliterate(cookiesObject.lang)
                    }}</span>
                  </li>
                </ul>
              </div>
              <div
                style="
                  padding-top: 10px;
                  padding-bottom: 10px;
                  text-align: center;
                "
              >
                <b-btn
                  variant="success"
                  style="
                    width: 160px;
                    background: #bb4250;
                    border: none;
                    border-radius: 2px;
                    font-size: 11px;
                    font-weight: bold;
                  "
                  @click="$refs['remove-modal'].show()"
                  >{{ $t("LanguageEn.remove") }}</b-btn
                >
              </div>
            </div>
            <div
              class="predict"
              v-else-if="
                (MatchStats.match.matchStatus.name == 'FT' &&
                  pred.gamePredictions.length !== 0) ||
                (MatchStats.match.matchStatus.name == 'AET' &&
                  pred.gamePredictions.length !== 0)
              "
            >
              <div
                style="
                  padding-bottom: 10px;
                  text-align: center;
                  font-size: 11px;
                "
                v-if="pred.gamePredictions[0].calculation !== null"
              >
                <div
                  style="
                    background-image: linear-gradient(#d04959, #79323a);
                    border: none;
                    height: 34px;
                    line-height: 34px;
                    border-radius: 2px;
                  "
                  v-if="getNumb(pred.gamePredictions[0].calculation) == 0"
                >
                  <img
                    src="@/assets/guessFa.svg"
                    style="margin-bottom: 4px"
                    alt=""
                  />
                  {{ $t("LanguageEn.guessF") }}
                </div>
                <div
                  style="
                    background-image: linear-gradient(#fab244, #be8733);
                    border: none;
                    height: 34px;
                    line-height: 34px;
                    border-radius: 2px;
                  "
                  v-else-if="
                    getNumb(pred.gamePredictions[0].calculation) > 0 &&
                    getNumb(pred.gamePredictions[0].calculation) < 499
                  "
                >
                  <img
                    src="@/assets/guessSu.svg"
                    style="margin-bottom: 4px"
                    alt=""
                  />
                  {{ $t("LanguageEn.guessS") }}
                </div>
                <div
                  style="
                    background-image: linear-gradient(#43a047, #2a6a2d);
                    border: none;
                    height: 34px;
                    line-height: 34px;
                    border-radius: 2px;
                  "
                  v-else-if="getNumb(pred.gamePredictions[0].calculation) > 499"
                >
                  <img
                    src="@/assets/guessPe.svg"
                    style="margin-bottom: 4px"
                    alt=""
                  />
                  {{ $t("LanguageEn.guessP") }}
                </div>
                <div
                  style="
                    background-image: linear-gradient(#a1a1a1, #5d5d5f);
                    border: none;
                    height: 34px;
                    line-height: 34px;
                    border-radius: 2px;
                  "
                  v-else
                >
                  <img
                    src="@/assets/guessWa.svg"
                    style="margin-bottom: 4px"
                    alt=""
                  />{{ $t("LanguageEn.guessS") }}
                </div>
              </div>
              <div
                class="row"
                style="
                  font-size: 13px;
                  height: 60px;
                  line-height: 60px;
                  margin-top: 40px;
                  margin-bottom: 40px;
                  color: #e6e6e6;
                "
              >
                <div
                  class="col"
                  :style="rtl ? 'text-align: left;' : 'text-align: right;'"
                >
                  <div class="row">
                    <p class="MobileHide col" style="font-weight: 600">
                      {{ team1name | transliterate(cookiesObject.lang) }}
                    </p>
                    <p
                      class="MobileShow col pr-0 pl-0"
                      style="font-weight: 600; font-size: 11px"
                    >
                      {{ team1name | transliterate(cookiesObject.lang) }}
                    </p>
                  </div>
                </div>
                <div class="col MobileHide" style="text-align: center">
                  <div class="row MobileHide" style="font-size: 21px">
                    <p
                      class="col ml-3"
                      style="
                        background: #212225;
                        border-radius: 2px;
                        border: 2px solid #27292c;
                        height: 60px;
                      "
                    >
                      {{
                        pred.gamePredictions[0].predictionValue.split("-")[0]
                          | transliterate(cookiesObject.lang)
                      }}
                    </p>
                    <p class="col pr-3 pl-3" style="background: ">-</p>
                    <p
                      class="col mr-3"
                      style="
                        background: #212225;
                        border-radius: 2px;
                        border: 2px solid #27292c;
                        height: 60px;
                      "
                    >
                      {{
                        pred.gamePredictions[0].predictionValue.split("-")[1]
                          | transliterate(cookiesObject.lang)
                      }}
                    </p>
                  </div>
                </div>
                <div
                  class="MobileShow col pr-0 pl-0"
                  style="text-align: center"
                >
                  <p style="font-weight: 600; color: white" class="col">
                    {{
                      pred.gamePredictions[0].predictionValue
                        | transliterate(cookiesObject.lang)
                    }}
                  </p>
                </div>
                <div
                  class="col"
                  :style="rtl ? 'text-align: right;' : 'text-align: left;'"
                >
                  <div class="row">
                    <p class="MobileHide col" style="font-weight: 600">
                      {{ team2name | transliterate(cookiesObject.lang) }}
                    </p>
                    <p
                      class="MobileShow col pr-0 pl-0"
                      style="font-weight: 600; font-size: 11px"
                    >
                      {{ team2name | transliterate(cookiesObject.lang) }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="container"
                v-if="pred.gamePredictions[0].calculation !== null"
                style="
                  color: lightgrey;
                  padding-bottom: 0px;
                  height: 34px;
                  line-height: 34px;
                "
              >
                <ul
                  class="row"
                  style="
                    list-style-type: none;
                    padding-left: 0px;
                    background: #212225;
                    font-size: 11px;
                    font-weight: 550;
                  "
                >
                  <div class="col">
                    {{ $t("LanguageEn.details") }}
                  </div>
                  <div class="col" style="text-align: center">
                    {{ $t("LanguageEn.gain") }}
                  </div>
                  <div class="col" style="text-align: center">
                    {{ $t("LanguageEn.result") }}
                  </div>
                </ul>
                <div style="font-size: 11px; color: #a3a3a3">
                  <li
                    class="row"
                    style="
                      list-style-type: none;
                      padding-left: 0px;
                      border-bottom: 1px solid rgba(169, 169, 169, 0.1);
                      height: 34px;
                      line-height: 34px;
                    "
                  >
                    <span class="col">
                      {{ $t("LanguageEn.bonus") }}
                    </span>
                    <span class="col" style="text-align: center">
                      {{
                        pred.gamePredictions[0].calculation.bonus
                          | transliterate(cookiesObject.lang)
                      }}
                    </span>
                    <span class="col" style="text-align: center">
                      <span
                        style="color: #43a047"
                        v-if="pred.gamePredictions[0].calculation.bonus > 0"
                      >
                        {{ $t("LanguageEn.bontext") }}</span
                      ><span
                        style="color: #d04959"
                        v-if="pred.gamePredictions[0].calculation.bonus == 0"
                      >
                        {{ $t("LanguageEn.bontext1") }}</span
                      >
                    </span>
                  </li>
                  <li
                    class="row"
                    style="
                      list-style-type: none;
                      padding-left: 0px;
                      border-bottom: 1px solid rgba(169, 169, 169, 0.1);
                      height: 34px;
                      line-height: 34px;
                    "
                  >
                    <span class="col">
                      {{ $t("LanguageEn.result") }}
                    </span>
                    <span class="col" style="text-align: center">
                      {{
                        pred.gamePredictions[0].calculation.result
                          | transliterate(cookiesObject.lang)
                      }}
                    </span>
                    <span class="col" style="text-align: center">
                      <span
                        style="color: #43a047"
                        v-if="pred.gamePredictions[0].calculation.result > 0"
                      >
                        {{ $t("LanguageEn.success") }}</span
                      ><span
                        style="color: #d04959"
                        v-if="pred.gamePredictions[0].calculation.result == 0"
                      >
                        {{ $t("LanguageEn.failure") }}</span
                      >
                    </span>
                  </li>
                  <li
                    class="row"
                    style="
                      list-style-type: none;
                      padding-left: 0px;
                      border-bottom: 1px solid rgba(169, 169, 169, 0.1);
                      height: 34px;
                      line-height: 34px;
                    "
                  >
                    <span class="col">
                      {{ $t("LanguageEn.matchScore") }}
                    </span>
                    <span class="col" style="text-align: center">
                      {{
                        pred.gamePredictions[0].calculation.matchScore
                          | transliterate(cookiesObject.lang)
                      }}
                    </span>
                    <span class="col" style="text-align: center">
                      <span
                        style="color: #43a047"
                        v-if="
                          pred.gamePredictions[0].calculation.matchScore > 0
                        "
                      >
                        {{ $t("LanguageEn.success") }}</span
                      ><span
                        style="color: #d04959"
                        v-if="
                          pred.gamePredictions[0].calculation.matchScore == 0
                        "
                      >
                        {{ $t("LanguageEn.failure") }}</span
                      >
                    </span>
                  </li>
                  <li
                    class="row"
                    style="
                      list-style-type: none;
                      padding-left: 0px;
                      border-bottom: 1px solid rgba(169, 169, 169, 0.1);
                      height: 34px;
                      line-height: 34px;
                    "
                  >
                    <span class="col">
                      {{ $t("LanguageEn.totalGoals") }}
                    </span>
                    <span class="col" style="text-align: center">
                      {{
                        pred.gamePredictions[0].calculation.totalGoals
                          | transliterate(cookiesObject.lang)
                      }}
                    </span>
                    <span class="col" style="text-align: center">
                      <span
                        style="color: #43a047"
                        v-if="
                          pred.gamePredictions[0].calculation.totalGoals > 0
                        "
                      >
                        {{ $t("LanguageEn.success") }}</span
                      ><span
                        style="color: #d04959"
                        v-if="
                          pred.gamePredictions[0].calculation.totalGoals == 0
                        "
                      >
                        {{ $t("LanguageEn.failure") }}</span
                      >
                    </span>
                  </li>
                  <li
                    class="row"
                    style="
                      list-style-type: none;
                      padding-left: 0px;
                      border-bottom: 1px solid rgba(169, 169, 169, 0.1);
                      height: 34px;
                      line-height: 34px;
                    "
                  >
                    <span class="col">
                      {{ $t("LanguageEn.scoredByAway") }}
                    </span>
                    <span class="col" style="text-align: center">
                      {{
                        pred.gamePredictions[0].calculation.goalsScoredByAway
                          | transliterate(cookiesObject.lang)
                      }}
                    </span>
                    <span class="col" style="text-align: center">
                      <span
                        style="color: #43a047"
                        v-if="
                          pred.gamePredictions[0].calculation
                            .goalsScoredByAway > 0
                        "
                      >
                        {{ $t("LanguageEn.success") }}</span
                      ><span
                        style="color: #d04959"
                        v-if="
                          pred.gamePredictions[0].calculation
                            .goalsScoredByAway == 0
                        "
                      >
                        {{ $t("LanguageEn.failure") }}</span
                      >
                    </span>
                  </li>
                  <li
                    class="row"
                    style="
                      list-style-type: none;
                      padding-left: 0px;
                      border-bottom: 1px solid rgba(169, 169, 169, 0.1);
                      height: 34px;
                      line-height: 34px;
                    "
                  >
                    <span class="col">
                      {{ $t("LanguageEn.scHome") }}
                    </span>
                    <span class="col" style="text-align: center">
                      {{
                        pred.gamePredictions[0].calculation.goalsScoredByHome
                          | transliterate(cookiesObject.lang)
                      }}
                    </span>
                    <span class="col" style="text-align: center">
                      <span
                        style="color: #43a047"
                        v-if="
                          pred.gamePredictions[0].calculation
                            .goalsScoredByHome > 0
                        "
                      >
                        {{ $t("LanguageEn.success") }}</span
                      ><span
                        style="color: #d04959"
                        v-if="
                          pred.gamePredictions[0].calculation
                            .goalsScoredByHome == 0
                        "
                      >
                        {{ $t("LanguageEn.failure") }}</span
                      >
                    </span>
                  </li>
                </div>
              </div>
            </div>
            <div v-else>
              <li class="list-group-item listHeader" style="border-radius: 0px">
                <img style="margin-bottom: 3px" src="@/assets/noInfo.svg" />{{
                  $t("LanguageEn.nsGames")
                }}
              </li>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>

    <b-modal
      ref="sure-modal"
      header-class="sureModal1"
      body-class="sureModal"
      size="md"
      hide-footer
      centered
      :title="$t('LanguageEn.yPrediction')"
    >
      <div class="row MobileHide" style="line-height: 50px; margin-top: 10px">
        <div class="col" style="text-align: right; font-size: 13px">
          {{ team1name | transliterate(cookiesObject.lang) }}
        </div>
        <div class="col">
          <div class="row" style="font-size: 21px; text-align: center">
            <p
              class="col ml-3"
              style="
                background: #212225;
                border-radius: 2px;
                border: 2px solid #27292c;
                height: 60px;
              "
            >
              {{ team1score | transliterate(cookiesObject.lang) }}
            </p>
            <p class="col pr-3 pl-3" style="background: ">-</p>
            <p
              class="col mr-3"
              style="
                background: #212225;
                border-radius: 2px;
                border: 2px solid #27292c;
                height: 60px;
              "
            >
              {{ team2score | transliterate(cookiesObject.lang) }}
            </p>
          </div>
        </div>
        <div class="col" style="text-align: left; font-size: 13px">
          {{ team2name | transliterate(cookiesObject.lang) }}
        </div>
      </div>
      <div class="MobileShow">
        <p class="row" style="font-size: 12px; text-align: center">
          <span class="col"
            >{{ team1name | transliterate(cookiesObject.lang) }}
          </span>
          <span class="col"
            >{{ team1score | transliterate(cookiesObject.lang) }} -
            {{ team2score | transliterate(cookiesObject.lang) }}</span
          >
          <span class="col">{{
            team2name | transliterate(cookiesObject.lang)
          }}</span>
        </p>
      </div>
      <b-row>
        <b-col style="text-align: center">
          <b-button
            type="submit"
            class="col"
            style="
              background: #2f5c28;
              border: none;
              border-radius: 2px;
              margin-top: 10px;
            "
            @click="guessScore(), $refs['sure-modal'].hide()"
            >{{ $t("LanguageEn.sbmit") }}</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      ref="remove-modal"
      header-class="sureModal1"
      body-class="sureModal"
      size="md"
      hide-footer
      centered
      title=""
    >
      <p style="text-align: center; font-size: 12px; color: #a3a3a3">
        {{ $t("LanguageEn.removeGuess") }}
      </p>
      <b-row>
        <b-col style="text-align: center">
          <b-button
            type="submit"
            class=""
            style="
              background: #bb4250;
              border: none;
              border-radius: 2px;
              width: 180px;
            "
            @click="
              deletePred(pred.gamePredictions[0].id),
                $refs['remove-modal'].hide()
            "
            >{{ $t("LanguageEn.remove") }}</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      ref="nb-modal"
      header-class="sureModal1"
      body-class="sureModal"
      size="md"
      hide-footer
      centered
      title="Zunisport"
    >
      <p style="text-align: center; font-size: 12px; color: #a3a3a3">
        {{ $t("LanguageEn.nb") }}
      </p>
      <b-row>
        <b-col style="text-align: center">
          <b-button
            type="submit"
            class=""
            style="
              background: #bb4250;
              border: none;
              border-radius: 2px;
              width: 180px;
            "
            @click="$refs['nb-modal'].hide()"
            >{{ $t("LanguageEn.ok") }}</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      style="z-index: 1000"
      ref="video-modal"
      header-class="sureModal1"
      body-class="sureModal"
      size="lg"
      hide-footer
      centered
      title="Zunisport TV"
    >
      <div style="z-index: 1000">
        <b-embed
          style="z-index: 1000"
          type="iframe"
          aspect="16by9"
          :src="vpath"
          allowfullscreen
        ></b-embed>
      </div>
    </b-modal>
    <div
      style="
        position: fixed;
        bottom: 40px;
        right: 20px;
        z-index: 1;
        cursor: pointer;
      "
    >
      <p style="background: none" v-if="ppp > 1200" @click="scrollToTop()">
        <img
          src="@/assets/upp.png"
          style="background: none; width: 50px"
          alt=""
        />
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "MatchPage",
  data() {
    return {
      MatchStats: [],
      leagueTable: [],
      gamesTween: [],
      gameId: "",
      teamLogo: "https://sportapi.zuniac.com/team/logo/",
      CountLogo: "https://sportapi.zuniac.com/category/logo/",
      playerLogo: "https://sportapi.zuniac.com/player/logo/",
      leagueId: "",
      team1name: "",
      team2name: "",
      teamID: "",
      id: "",
      cookiesObject: "",
      max: 100,
      newArray1: [],
      newArray2: [],
      summedArray: [],
      penArray: [],
      standings: [],
      standings1: [],
      summedline: [],
      tournId: "",
      team1score: 0,
      team2score: 0,
      ppp: "",
      comms: "",
      languages: "",
      ss: "1",
      pred: "",
      Overlay: false,
      tabIndex: 0,
      show1: 0,
      show2: 0,
      favImage: require("@/assets/favorite.svg"),
      favImage1: require("@/assets/orStar.png"),
      team: "team",
      comShow: 1,
      currentState: false,
      team1F: null,
      team2F: null,
      defArr: [],
      midArr: [],
      attArr: [],
      addArr: [],
      defArr2: [],
      midArr2: [],
      attArr2: [],
      addArr2: [],
      gKeeper1: "",
      gKeeper2: "",
      mainLineup1: "",
      mainLineup2: "",
      subLineup1: "",
      subLineup2: "",
      vpath: "",
      rs: "",
      gs: "",
    };
  },
  async beforeMount() {
    this.id = this.$route.params.gameId;

    if (this.$route.params.index) {
      this.tabIndex = 3;
    }

    var cookiesObject = document.cookie
      .split(";")
      .map((cookie) => cookie.split("="))
      .reduce(
        (accumulator, [key, value]) => ({
          ...accumulator,
          [key.trim()]: decodeURIComponent(value),
        }),
        {}
      );
    this.cookiesObject = cookiesObject;

    window.addEventListener("scroll", this.onScroll);

    this.langList();

    this.gamePr();

    this.getData();

    this.fField();

    setInterval(() => {
      this.getData();
    }, 50000);
  },
  components: {},

  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
    clearInterval(this.setInterval);
  },
  methods: {
    ...mapActions(["removeFavorite", "addToFavorites", "getBalance"]),
    swipeLHandler() {
      this.$router.go(-1);
    },
    async getData() {
      var offset = new Date().getTimezoneOffset();

      if (this.cookiesObject.token) {
        var res = await fetch(
          this.httpReq +
            "/match?matchId=" +
            this.id +
            "&portalId=" +
            (this.cookiesObject.portalId ? this.cookiesObject.portalId : 0) +
            "&timezone=%2B" +
            offset / -60 +
            "%3A00&token=" +
            this.cookiesObject.token
        );
        var data = await res.json();
        var MatchStats = data;
        this.MatchStats = MatchStats;
        this.comms = MatchStats.match.commentaries;
        this.tournId = MatchStats.match.tournament.id;
        this.team1name = MatchStats.match.team1.name;
        this.team2name = MatchStats.match.team2.name;

        if (MatchStats.match.notificationEnabled == 1) {
          this.currentState = true;
        } else {
          this.currentState = false;
        }

        if (data.code == 200) {
          //everything is okay
        } else if (data.code == 401) {
          alert(this.$t("LanguageEn.logText"));
          document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
          document.cookie = "langId = 1";
          document.cookie = "lang = en";
          document.cookie =
            "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
          document.cookie =
            "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
          location.assign("/");
        } else if (data.code == 404) {
          alert("you dont have access to this match");
          document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
          document.cookie = "langId = 1";
          document.cookie = "lang = en";
          document.cookie =
            "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
          document.cookie =
            "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
          location.assign("/");
        } else {
          alert("server error");
          document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
          document.cookie = "langId = 1";
          document.cookie = "lang = en";
          document.cookie =
            "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
          document.cookie =
            "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
          location.assign("/");
        }
      } else {
        var resp = await fetch(
          this.httpReq +
            "/match?matchId=" +
            this.id +
            "&portalId=" +
            (this.cookiesObject.portalId ? this.cookiesObject.portalId : 0) +
            "&timezone=%2B" +
            offset / -60 +
            "%3A00"
        );
        var datas = await resp.json();
        var MatchStatss = datas;
        this.MatchStats = MatchStatss;
        this.tournId = MatchStatss.match.tournament.id;
      }

      const res1 = await fetch(
        this.httpReq +
          "/standings?portalId=" +
          (this.cookiesObject.portalId ? this.cookiesObject.portalId : 0) +
          "&token=" +
          this.cookiesObject.token +
          "&tournamentId=" +
          this.MatchStats.match.tournament.id
      );
      const data1 = await res1.json();
      //  const leagueTable = data1;
      this.leagueTable = data1.standings;

      const res2 = await fetch(
        this.httpReq +
          "/match/h2h?matchId=" +
          this.id +
          "&portalId=" +
          (this.cookiesObject.portalId ? this.cookiesObject.portalId : 0) +
          "&timezone=%2B" +
          offset / -60 +
          "%3A00"
      );
      const data2 = await res2.json();
      const gamesTween = data2;
      this.gamesTween = gamesTween;

      this.rs = this.leagueTable.filter(
        (gr) => gr.stage.name == "Regular Season"
      );
      this.gs = this.leagueTable.filter((gr) => gr.stage.name == "Group Stage");

      this.standings = this.groupBy(this.rs, "groupName");
      this.standings1 = this.groupBy(this.gs, "groupName");

      if (MatchStats.match.events[0]) {
        this.newArray1 = MatchStats.match.events[0].events.map(function (el) {
          var o = Object.assign({}, el);
          o.team = "team1";
          return o;
        });
      } else {
        this.newArray1 = [];
      }

      if (MatchStats.match.events[1]) {
        this.newArray2 = MatchStats.match.events[1].events.map(function (el) {
          var o = Object.assign({}, el);
          o.team = "team2";
          return o;
        });
      } else {
        this.newArray2 = [];
      }

      this.summedArray = this.newArray1.concat(this.newArray2);

      this.summedArray.sort(function (a, b) {
        return parseInt(a.eventTime) - parseInt(b.eventTime);
      });

      // var lineuparr1 = MatchStats.match.lineups[0].players.map(function(el){
      //   var o = Object.assign({},el);
      //   o.team = 'team1';
      //   return o;
      // });

      // var lineuparr2 = MatchStats.match.lineups[1].players.map(function(el){
      //   var o = Object.assign({},el);
      //   o.team = 'team2';
      //   return o;
      // });

      // this.summedline = lineuparr1.concat(lineuparr2);
      // console.log(this.summedline)

      this.penArray = this.summedArray.filter(
        (event) =>
          event.eventType == "pen_shootout_miss" ||
          event.eventType == "pen_shootout_goal"
      );
      this.summedArray = this.summedArray.filter(
        (event) =>
          event.eventType != "pen_shootout_miss" &&
          event.eventType != "pen_shootout_goal"
      );

      this.show1 = this.summedArray.filter(
        (event) => parseInt(event.eventTime) <= 45
      ).length;
      this.show2 = this.summedArray.filter(
        (event) => parseInt(event.eventTime) > 45
      ).length;

      this.$forceUpdate();
    },
    setNot() {
      var requestOptions = {
        method: "PUT",
        redirect: "follow",
      };

      if (this.currentState == true) {
        var sent = 1;
      } else {
        sent = 0;
      }

      fetch(
        "https://sportapi.zuniac.com/user/match-notifications?matchId=" +
          this.id +
          "&status=" +
          sent +
          "&token=" +
          this.cookiesObject.token,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => console.log(result))
        .catch((error) => console.log("error", error));
    },
    getNumb(val) {
      const sumValues = (obj) => Object.values(obj).reduce((a, b) => a + b);
      return sumValues(val);
    },
    async fField() {
      var offset = new Date().getTimezoneOffset();

      var res = await fetch(
        this.httpReq +
          "/match?matchId=" +
          this.id +
          "&portalId=" +
          (this.cookiesObject.portalId ? this.cookiesObject.portalId : 0) +
          "&timezone=%2B" +
          offset / -60 +
          "%3A00&token=" +
          this.cookiesObject.token
      );
      var data = await res.json();
      var lineups1 = data.match.lineups[0];
      var lineups2 = data.match.lineups[1];

      this.mainLineup1 = lineups1.players.filter(
        (player) => player.substitute == 0
      );

      this.mainLineup1.sort(function (a, b) {
        return b.position - a.position;
      });

      this.mainLineup1.reverse();

      this.mainLineup2 = lineups2.players.filter(
        (player) => player.substitute == 0
      );

      this.mainLineup2.sort(function (a, b) {
        return b.position - a.position;
      });

      this.mainLineup2.reverse();

      this.subLineup1 = lineups1.players.filter(
        (player) => player.substitute == 1
      );
      this.subLineup2 = lineups2.players.filter(
        (player) => player.substitute == 1
      );

      const lineups3 = lineups1.players.filter(
        (player) => player.substitute == 0
      );
      const lineups4 = lineups2.players.filter(
        (player) => player.substitute == 0
      );

      this.gKeeper1 = lineups1.players.filter((player) => player.position == 1);
      this.gKeeper2 = lineups2.players.filter((player) => player.position == 1);

      // Lenght of array

      var team1F = data.match.team1Formation.split("-").length;
      this.team1F = team1F;

      if (team1F == 3) {
        var def1 = parseInt(data.match.team1Formation.split("-")[0]);
        this.defArr = lineups3.filter(
          (player) => player.position > 1 && player.position < def1 + 2
        );

        var mid1 = parseInt(data.match.team1Formation.split("-")[1]);
        this.midArr = lineups3.filter(
          (player) =>
            player.position > def1 + 1 && player.position < def1 + mid1 + 2
        );

        this.attArr = lineups3.filter(
          (player) => player.position > def1 + mid1 + 1 && player.position < 12
        );
      } else {
        var def11 = parseInt(data.match.team1Formation.split("-")[0]);
        this.defArr = lineups3.filter(
          (player) => player.position > 1 && player.position < def11 + 2
        );

        var mid11 = parseInt(data.match.team1Formation.split("-")[1]);
        this.midArr = lineups3.filter(
          (player) =>
            player.position > def11 + 1 &&
            player.position < def11 + 1 + (mid11 + 1)
        );

        var att11 = parseInt(data.match.team1Formation.split("-")[2]);
        this.attArr = lineups3.filter(
          (player) =>
            player.position > def11 + mid11 + 1 &&
            player.position < def11 + mid11 + att11 + 2
        );

        this.addArr = lineups3.filter(
          (player) =>
            player.position > def11 + mid11 + att11 + 1 && player.position < 12
        );
      }

      this.defArr.sort(function (a, b) {
        return b.position - a.position;
      });
      this.midArr.sort(function (a, b) {
        return b.position - a.position;
      });
      this.attArr.sort(function (a, b) {
        return b.position - a.position;
      });
      this.addArr.sort(function (a, b) {
        return b.position - a.position;
      });

      var team2F = data.match.team2Formation.split("-").length;
      this.team2F = team2F;

      if (team2F == 3) {
        var def2 = parseInt(data.match.team2Formation.split("-")[0]);
        this.defArr2 = lineups4.filter(
          (player) => player.position > 1 && player.position < def2 + 2
        );

        var mid2 = parseInt(data.match.team2Formation.split("-")[1]);
        this.midArr2 = lineups4.filter(
          (player) =>
            player.position > def2 + 1 && player.position < def2 + mid2 + 2
        );

        this.attArr2 = lineups4.filter(
          (player) => player.position > def2 + mid2 + 1 && player.position < 12
        );
      } else {
        var def22 = parseInt(data.match.team2Formation.split("-")[0]);
        this.defArr2 = lineups4.filter(
          (player) => player.position > 1 && player.position < def22 + 2
        );

        var mid22 = parseInt(data.match.team2Formation.split("-")[1]);
        this.midArr2 = lineups4.filter(
          (player) =>
            player.position > def22 + 1 &&
            player.position < def22 + 1 + (mid22 + 1)
        );

        var att22 = parseInt(data.match.team2Formation.split("-")[2]);
        this.attArr2 = lineups4.filter(
          (player) =>
            player.position > def22 + mid22 + 1 &&
            player.position < def22 + mid22 + att22 + 2
        );

        this.addArr2 = lineups4.filter(
          (player) =>
            player.position > def22 + mid22 + att22 + 1 && player.position < 12
        );
      }

      this.defArr2.sort(function (a, b) {
        return b.position - a.position;
      });
      this.midArr2.sort(function (a, b) {
        return b.position - a.position;
      });
      this.attArr2.sort(function (a, b) {
        return b.position - a.position;
      });
      this.addArr2.sort(function (a, b) {
        return b.position - a.position;
      });
    },
    deletePred(val) {
      var myHeaders = new Headers();
      myHeaders.append(
        "Cookie",
        "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765"
      );

      var requestOptions = {
        method: "DELETE",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(
        this.httpReq +
          "/game/prediction?token=" +
          this.cookiesObject.token +
          "&predictionId=" +
          val,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          console.log(result.message);
          this.gamePr();
          this.getBalance();
          this.$forceUpdate();
        })
        .catch((error) => console.log("error", error));
    },
    async langList() {
      const res = await fetch(
        this.httpReq +
          "/general/appData?portalId=" +
          (this.cookiesObject.portalId ? this.cookiesObject.portalId : 0),
        { method: "get" }
      );
      const data = await res.json();
      const languages = data.portal.languages;
      this.languages = languages;
    },
    onScroll(e) {
      this.ppp = e.target.documentElement.scrollTop;
    },
    scrollToTop() {
      window.scrollTo(0, 250);
    },
    gamePr() {
      var myHeaders = new Headers();
      myHeaders.append(
        "Cookie",
        "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765"
      );

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(
        this.httpReq +
          "/game/predictions?matchId=" +
          this.id +
          "&timezone=%2B04%3A00&token=" +
          this.cookiesObject.token,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          this.pred = result;
        })
        .catch((error) => console.log("error", error));
    },
    translate(val) {
      var myHeaders = new Headers();
      myHeaders.append(
        "Cookie",
        "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765"
      );

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(
        this.httpReq +
          "/match/commentaries/translate?languageId=" +
          (val ? val : 0) +
          "&matchId=" +
          this.id +
          "&token=" +
          this.cookiesObject.token,
        requestOptions
      )
        .then((response) => response.json())
        .then((this.Overlay = true))
        .then((result) => {
          this.comms = result.commentaries;
          this.$forceUpdate();
        })
        .then((result) => {
          console.log(result);
          this.Overlay = false;
        })
        .catch((error) => console.log("error", error));
    },
    goto() {
      this.$router.push({ name: "PredictionsList", params: {} });
    },
    guessScore() {
      var myHeaders = new Headers();
      myHeaders.append(
        "Cookie",
        "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765"
      );

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(
        this.httpReq +
          "/game/prediction?matchId=" +
          this.id +
          "&predictionValue=" +
          this.team1score +
          "-" +
          this.team2score +
          "&timezone=%2B04%3A00&token=" +
          this.cookiesObject.token,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.code == 200) {
            this.gamePr();
            this.getBalance();
            this.$forceUpdate();
          } else if (result.code == 409) {
            this.$refs["nb-modal"].show();
          } else {
            alert(result.message);
          }
        })
        .catch((error) => console.log("error", error));
    },
    openPlayer(val) {
      window.open(val, "newwin", "height=600px, width=900px");
    },
    emitToParent() {
      this.$emit("childToParent", this.id);
    },
    groupBy(objectArray, property) {
      return objectArray.reduce((acc, obj) => {
        const key = obj[property];
        if (!acc[key]) {
          acc[key] = [];
        }
        // Add object to list for given key's value
        acc[key].push(obj);
        return acc;
      }, {});
    },

    calculateMinutes(value) {
      if (value == null) {
        return "LIVE";
      } else {
        var startDate = new Date(value.replace(" ", "T"));
        var endDate = Date.now();
        var difference = (endDate - startDate) / 1000 / 60;

        if (difference < 0) {
          difference = difference + 240;
        }

        return parseInt(difference);
      }
    },
  },
  computed: {
    ...mapGetters(["favs", "httpReq", "rtl"]),
    isActive() {
      return this.currentState;
    },
    checkedValue: {
      get() {
        return this.currentState;
      },
      set(newValue) {
        this.currentState = newValue;
      },
    },
  },
};
</script>

<style scoped>
.toggle__button {
  vertical-align: middle;
  user-select: none;
  cursor: pointer;
}
.toggle__button input[type="checkbox"] {
  opacity: 0;
  position: absolute;
  width: 1px;
  height: 1px;
}
.toggle__button .toggle__switch {
  display: inline-block;
  height: 12px;
  border-radius: 6px;
  width: 40px;
  background: #bfcbd9;
  box-shadow: inset 0 0 1px #bfcbd9;
  position: relative;
  margin-left: 10px;
  transition: all 0.25s;
}
.toggle__button .toggle__switch::after,
.toggle__button .toggle__switch::before {
  content: "";
  position: absolute;
  display: block;
  height: 18px;
  width: 18px;
  border-radius: 50%;
  left: 0;
  top: -3px;
  transform: translateX(0);
  transition: all 0.25s cubic-bezier(0.5, -0.6, 0.5, 1.6);
}
.toggle__button .toggle__switch::after {
  background: #4d4d4d;
  box-shadow: 0 0 1px #666;
}
.toggle__button .toggle__switch::before {
  background: #4d4d4d;
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
  opacity: 0;
}
.active .toggle__switch {
  background: #46944a;
  box-shadow: inset 0 0 1px #bfcbd9;
}
.active .toggle__switch::after,
.active .toggle__switch::before {
  transform: translateX(40px - 18px);
}
.active .toggle__switch::after {
  left: 23px;
  background: #43a047;
}
.uline {
  border-bottom: 3px solid green;
}
.gwg {
  text-decoration: underline;
  text-decoration-color: #43a047;
  text-decoration-thickness: 1.5px;
}
.fF {
  background-image: url("st.svg");
  background-repeat: no-repeat;
  background-position: center;
  margin-bottom: 15px;
}
.rCl {
  padding-left: 15%;
  padding-right: 15%;
}
.ybg {
  font-weight: 800px;
  background: #be8733 !important;
}
.pop1 {
  animation: color-change 1.2s infinite;
}
@keyframes color-change {
  0% {
    color: #a43d4a;
  }
  50% {
    color: red;
  }
  100% {
    color: #a43d4a;
  }
}
.slang {
  color: #009246;
  font-weight: 550;
}
.rbg {
  background: #2c2d31 !important;
}
.Fnames {
  font-size: 12px;
}
.plImage {
  height: 40px;
  width: 40px;
}
.import {
  color: white;
  font-weight: 550;
}

.team2 {
  text-align: right;
  margin-right: 0px;
}
.blackBg {
  background: #2c2d31 !important;
}
.predict {
  background: #141416;
}
.yellowBg {
  background: #2a251f !important;
}

.Loc {
  background: #212226;
  width: 100%;
  height: 250px;
}
.circle {
  background: #333333;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.leagueNam {
  text-align: center;
  font-size: 18px;
  color: white;
}

/* Navbar (info, H2H, etc.) */

.navDiv2 {
  width: 100%;
  height: 60px;
  color: white;
  background-image: linear-gradient(#fefefe, #c3c3c3);
}

#topheader2 .navbar-nav li > a {
  text-transform: capitalize;
  transition: background-color 0.2s, color 0.2s;
}

#topheader2 .navbar-nav li > a:focus {
  background-image: linear-gradient(#39b44a, #39b54a);
  color: #fff !important;
}

#topheader2 .navbar-nav li.active > a {
  background-color: #333;
  color: #fff;
}

#routerLink {
  padding-top: 10%;
  display: inline-block;
  text-decoration: none;
  width: 111px !important;
  height: 60px !important;
  /* color: black; */
  text-align: center !important;
  margin-top: -8px;
}
#routerLink .navbar-nav li > a {
  text-transform: capitalize;
  transition: background-color 0.2s, color 0.2s;
}

#routerLink .navbar-nav li > a:focus {
  background-image: linear-gradient(#39b44a, #1b5f20);
  color: #fff !important;
}

#routerLink .navbar-nav li.active > a {
  background-color: #333;
  color: #fff;
}

.Info {
  width: 100%;
}

.list-group-item {
  line-height: 15px;
}

.listHeader {
  background-color: #2c2d31 !important;
  color: white;
  text-align: center;
  font-weight: 400;
  font-size: 13px;
}

.infoItem {
  background-color: #212226;
  color: white;
  /* border-color: #333333 !important;
border-width: 1px !important; */
}

/* bottom of the page info css (referee, stadium) */

.referee {
  background-color: #141416 !important;
  color: lightgrey;
  border: none;
}

@media only screen and (max-width: 600px) {
  body {
    background: #212529;
  }
  .Fnames {
    font-size: 10px;
  }
  .rCl {
    padding-left: 0px;
    padding-right: 0px;
  }
  .plImage {
    height: 35px;
    width: 35px;
  }
  .Loc {
    background: #212226;
    width: 100% !important;
  }
  .blackBg {
    background: #e6e6e6;
  }
  .navDiv2 {
    width: 100%;
    height: 60px;
    color: white;
    background: #1b1d20;
  }
  .leagueNam {
    text-align: center;
    padding-top: 20px;
    font-size: 15px;
    color: white;
    justify-content: center;
  }

  .MobileHide {
    display: none;
  }
}

@media only screen and (max-width: 770px) {
  body {
    background: #212529;
  }
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }
}
</style>
<style>
.bi-plus {
  fill: #1b5e20;
}
.bi-dash {
  fill: #1b5e20;
}
.spinner-border {
  display: table;
  margin: 0 auto;
  margin-top: 20px;
  color: green;
}

@media only screen and (max-width: 770px) {
  /* .nav-tabs {
flex-wrap: nowrap;
white-space: nowrap;
max-width: 770px;
overflow: auto;
} */
}
.tab11 {
  background-color: none !important;
}
.ks {
  background: none !important;
  border-radius: 0px !important;
  border-bottom: solid #357439 !important;
  border-width: 3px !important;
  border-left: none !important;
  border-right: none !important;
  border-top: none !important;
}
.ks1 {
  background: none !important;
  border-radius: 0px !important;
  border: none;
}
.ks4 {
  background: #1b5e20 !important;
  border-radius: 0px !important;
  border: none !important;
}
.ks41 {
  background: none !important;
  border-radius: 0px !important;
  border: none;
}
.sureModal1 {
  background: #212225;
  color: lightgrey;
  border: none;
  font-size: 12px !important;
}
.sureModal1 .modal-title {
  font-size: 15px !important;
}

.sureModal {
  background: #1a1a1d;
  color: lightgrey;
}
.sureModal1 .close {
  color: white !important;
}
.sureModal .close {
  color: white !important;
}
</style>
